(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6219,1555,9635],{

/***/ 71843:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

exports.Z = _default;

/***/ }),

/***/ 29973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports.Z = _default;

/***/ }),

/***/ 1197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos');

exports.Z = _default;

/***/ }),

/***/ 88995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.Z = _default;

/***/ }),

/***/ 75332:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(15838);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WU": function() { return /* binding */ PLZ_REGEX; },
/* harmony export */   "d0": function() { return /* binding */ PHONE_NUMBER_REGEX; },
/* harmony export */   "f": function() { return /* binding */ CUSTOMER_LEAD_RECORD_TYPE; },
/* harmony export */   "z3": function() { return /* binding */ GET_POSTCODE_REGEXP; }
/* harmony export */ });
/* unused harmony export DEFAULT_CITY */
var PHONE_NUMBER_REGEX = /\b[+]?[(]?[0-9]{2,6}[)]?[-\s.]?[-\s/.0-9]{3,15}\b/;
var PLZ_REGEX = /[A-Z0-9 -]{3,}/;
var CUSTOMER_LEAD_RECORD_TYPE = "01258000000DWRx";
var DEFAULT_CITY = "berlin";
var GET_POSTCODE_REGEXP = /[\d]+[A-Z]*/g;


/***/ }),

/***/ 89329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ webToLeadData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);




var webToLeadData = function(values) {
    var _obj;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.oid, "00D58000000ZImI"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.lead_source, "heycater.com Web2Lead form"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.entrance_url, js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("entrance_url")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.referrer_url, js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("referrer_url")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.conversion_url, window.location.href), _obj), Object.keys(values).reduce(function(accumulator, key) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, accumulator), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, salesforceFieldMapping[key], values[key]));
    }, {}));
};
var salesforceFieldMapping = {
    entrance_url: "00N1i000001A0eY",
    referrer_url: "00N1i000001A0eT",
    lead_source: "lead_source",
    conversion_url: "00N1i000002WWRT",
    last_name: "last_name",
    name: "last_name",
    email: "email",
    phone: "phone",
    comment: "00N58000007Q0vz",
    record_type: "recordType",
    oid: "oid",
    city: "00N5800000CZO0T",
    caterer_type: "00N1i000002IQkc",
    first_name: "first_name",
    zip_code: "zip",
    address: "street",
    caterer_name: "company"
};


/***/ }),

/***/ 79635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55352);






function ContentfulImage(_param) {
    var src = _param.src, width = _param.width, height = _param.height, _layout = _param.layout, layout = _layout === void 0 ? "responsive" : _layout, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "height",
        "layout",
        "alt"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        alt: alt,
        src: (0,hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getContentfulImageUrl */ .l)(src),
        width: width,
        height: height,
        layout: layout,
        objectFit: "cover",
        quality: "85"
    }, restProps));
}
/* harmony default export */ __webpack_exports__["default"] = (ContentfulImage);


/***/ }),

/***/ 95717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Sticky; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70131);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85444);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: -",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: all 0.3s ease-out;\n  z-index: 50;\n  position: sticky;\n  top: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Sticky = function(_param) {
    var children = _param.children, top = _param.top, hideOnScroll = _param.hideOnScroll, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "top",
        "hideOnScroll"
    ]);
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), prevScrollY = ref1[0], setPrevScrollY = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isHiddenOnScroll = ref2[0], setHiddenOnScroll = ref2[1];
    var ref3 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_5__/* .useInView */ .YD)({
        threshold: 1
    }), ref4 = ref3.ref, entry = ref3.entry;
    var height = entry === null || entry === void 0 ? void 0 : (ref = entry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.height;
    var handleScroll = function() {
        if (!hideOnScroll) return;
        var currentScrollY = window.scrollY;
        var scrollDirection = currentScrollY < prevScrollY ? "up" : "down";
        if (window.scrollY === 0 || prevScrollY == currentScrollY) {
            return;
        }
        if (scrollDirection === "down") {
            setHiddenOnScroll(true);
        }
        if (scrollDirection === "up") {
            setHiddenOnScroll(false);
        }
        setPrevScrollY(currentScrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        hideOnScroll,
        prevScrollY
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        ref: ref4,
        height: height,
        hideOnScroll: hideOnScroll,
        isHiddenOnScroll: isHiddenOnScroll,
        top: top
    }, restProps), {
        children: children
    }));
};
var StickyContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject1(), function(param) {
    var top = param.top;
    return top || 0;
}, function(param) {
    var hideOnScroll = param.hideOnScroll, isHiddenOnScroll = param.isHiddenOnScroll, height = param.height;
    return hideOnScroll && isHiddenOnScroll && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject(), height);
});


/***/ }),

/***/ 15838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hub/helpers/contentful.tsx
var contentful = __webpack_require__(55352);
;// CONCATENATED MODULE: ./src/lib/contentful/cateringCategoryMapping.ts
var contentfulToCateringCategoryMapping = {
    bbq: "bbq",
    breakfast: "breakfast",
    buffet: "buffet",
    business_lunch: "business_lunch",
    cakes_and_sweets: "cakes_and_sweets",
    christmas: "christmas",
    cocktailbar: "drinks",
    dessert: "cakes_and_sweets",
    dinner: "fine_dining",
    drinks: "drinks",
    fine_dining: "fine_dining",
    fingerfood: "fingerfood",
    foodtruck: "street_food",
    street_food: "street_food",
    summer_party: "summer_party",
    event: "other"
};
var parseContentfulCateringCategory = function(category) {
    return contentfulToCateringCategoryMapping[category];
};
var parseContentfulCateringCategories = function(categories) {
    if (!categories) {
        return undefined;
    }
    if (categories) {
        return categories.reduce(function(acc, category) {
            var mappedValue = parseContentfulCateringCategory(category);
            if (mappedValue) {
                acc.push(mappedValue);
            }
            return acc;
        }, []);
    }
};

// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/schema/questions/cityQuestion.tsx
var cityQuestion = __webpack_require__(26407);
;// CONCATENATED MODULE: ./src/qualification/hooks/usePreselectedCity.ts



var useCity = function() {
    var cityFromPath = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).cityFromPath;
    var ref = (0,react.useState)(undefined), city = ref[0], setCity = ref[1];
    (0,react.useEffect)(function() {
        var fetchedCity = cityFromPath || (0,cities/* getCityInLocalStorage */.iZ)() || undefined;
        if (fetchedCity) {
            fetchedCity = (0,cityQuestion/* isValidCity */.m0)(fetchedCity) ? fetchedCity : "other";
        }
        setCity(fetchedCity);
    }, [
        cityFromPath
    ]);
    return city;
};
/* harmony default export */ var usePreselectedCity = (useCity);

// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/PageSections.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scroll-margin-top: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var PageSectionContext = /*#__PURE__*/ (0,react.createContext)(null);
var PageSectionProvider = function(param) {
    var children = param.children, _pageTopOffset = param.pageTopOffset, pageTopOffset = _pageTopOffset === void 0 ? 160 : _pageTopOffset;
    var ref = (0,react.useState)(null), activeSection = ref[0], setActiveSection = ref[1];
    var ref1 = (0,react.useState)([]), trackedSections = ref1[0], setTrackedSections = ref1[1];
    var addSection = function(param) {
        var id = param.id, label = param.label;
        return setTrackedSections(function(prevSections) {
            var sectionAlreadyTracked = prevSections.find(function(prevSection) {
                return prevSection.id === id;
            });
            if (sectionAlreadyTracked) {
                return prevSections;
            } else {
                return (0,_to_consumable_array/* default */.Z)(prevSections).concat([
                    {
                        id: id,
                        label: label
                    }
                ]);
            }
        });
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var currentPosition = window.pageYOffset;
            var activeSection = null;
            trackedSections.forEach(function(section) {
                var sectionElement = document.getElementById(section.id);
                if (sectionElement) {
                    var offsetTop = sectionElement.offsetTop, offsetHeight = sectionElement.offsetHeight;
                    var allowance = 30;
                    if (currentPosition >= offsetTop - pageTopOffset - allowance && currentPosition < offsetTop + pageTopOffset + offsetHeight) {
                        activeSection = section;
                    }
                }
            });
            setActiveSection(activeSection);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        trackedSections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSectionContext.Provider, {
        value: {
            activeSection: activeSection,
            sections: trackedSections,
            addSection: addSection,
            topOffset: pageTopOffset
        },
        children: children
    });
};
var TrackedSection = function(_param) {
    var id = _param.id, label = _param.label, children = _param.children, _isTracked = _param.isTracked, isTracked = _isTracked === void 0 ? true : _isTracked, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "id",
        "label",
        "children",
        "isTracked"
    ]);
    var ref = PageSections_useCurrentSection(), addSection = ref.addSection, topOffset = ref.topOffset;
    (0,react.useEffect)(function() {
        if (isTracked) {
            addSection({
                id: id,
                label: label
            });
        }
    }, [
        isTracked
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedSectionBox, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        scrollTopOffset: topOffset,
        id: id,
        as: "section"
    }, props), {
        children: children
    }));
};
var TrackedSectionBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject(), function(param) {
    var scrollTopOffset = param.scrollTopOffset;
    return scrollTopOffset;
});
var PageSections_useCurrentSection = function() {
    var context = (0,react.useContext)(PageSectionContext);
    if (!context) {
        throw new Error("useCurrentSection is used outside of it's provider");
    }
    return context;
};
var PageSections = {
    Provider: PageSectionProvider,
    TrackedSection: TrackedSection
};
/* harmony default export */ var components_PageSections = (PageSections);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
;// CONCATENATED MODULE: ./src/static_pages/dynamic_page/index.jsx











function DynamicLandingPage(param) {
    var page = param.page, ratings = param.ratings;
    var ref;
    var parsedCateringCategories = parseContentfulCateringCategories(page.keywords);
    var city = usePreselectedCity({
        cityFromPath: page.city
    });
    var body = (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(page.body, (0,contentful/* embeddedAssetOptions */.k)({
        ratings: ratings
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
        ratings: ratings,
        renderNavbarCta: function() {
            return null;
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* QualificationProvider */.S, {
            storage: null,
            initialized: {
                nonSkippableQuestions: [
                    "catering_categories"
                ],
                answers: {
                    city: city,
                    catering_categories: parsedCateringCategories
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: page.metaTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: page.metaDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: page.metaTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: page.metaDescription
                        }),
                        page.faQsEnabled && (page === null || page === void 0 ? void 0 : (ref = page.faQs) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify((0,helpers/* buildFaqMarkup */.bB)(page.faQs))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSections.Provider, {
                    children: body
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./src/shared/services/trustedShops/fetchRatings.ts
var trustedShops_fetchRatings = __webpack_require__(35853);
// EXTERNAL MODULE: ./src/static_pages/components/CTAWithBenefits/index.tsx + 2 modules
var CTAWithBenefits = __webpack_require__(58308);
// EXTERNAL MODULE: ./src/static_pages/components/FooterLinks.tsx
var FooterLinks = __webpack_require__(6029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/static_pages/components/CitySelector.tsx
var CitySelector = __webpack_require__(1183);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/static_pages/components/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -150px;\n  left: -150px;\n\n  ",
        " {\n    left: -250px;\n  }\n\n  ",
        " {\n    width: 200px;\n    left: -50px;\n    bottom: -50px;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -200px;\n  right: -50px;\n  transform: rotate(-45deg);\n\n  ",
        " {\n    width: 100px;\n    right: 0;\n    bottom: -80px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -20px;\n  left: 0px;\n  ",
        " {\n    width: 300px;\n    left: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -10px;\n  right: 0px;\n  ",
        " {\n    width: 300px;\n    right: -30px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -20px;\n  left: -50px;\n  transform: rotate(15deg);\n  ",
        " {\n    width: 300px;\n    left: -120px;\n    bottom: -0px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -10px;\n  right: -10px;\n  ",
        " {\n    width: 200px;\n    right: -60px;\n    bottom: -30px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  ",
        " {\n    width: 220px;\n    bottom: 0;\n  }\n  ",
        " {\n    width: 150px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0px;\n  right: 0px;\n  ",
        " {\n    width: 220px;\n    bottom: 0;\n    right: 0;\n  }\n  ",
        " {\n    width: 150px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -50px;\n  left: -50px;\n  ",
        " {\n    width: 220px;\n    bottom: -45px;\n    left: -45px;\n  }\n  ",
        " {\n    width: 200px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -50px;\n  right: -50px;\n  ",
        " {\n    width: 220px;\n    bottom: -35px;\n    right: -35px;\n  }\n  ",
        " {\n    width: 200px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -10px;\n  left: -10px;\n  ",
        " {\n    width: 220px;\n    bottom: 0px;\n    left: 0px;\n  }\n  ",
        " {\n    width: 200px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -100px;\n  right: -100px;\n  ",
        " {\n    width: 220px;\n    bottom: -35px;\n    right: -35px;\n  }\n  ",
        " {\n    width: 150px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: -20px;\n  right: 0px;\n  ",
        " {\n    width: 200px;\n    bottom: 0;\n    right: 0;\n  }\n  ",
        " {\n    width: 150px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

var HeroLeftWrapper = styled_components_browser_esm/* default.div */.ZP.div(styles_templateObject(), function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var HeroRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var VeganLeftWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var VeganRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var FingerFoodLeftWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var FingerFoodRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var CocktailLeftWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var CocktailRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var BaseLeftWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var BaseRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var FoodTruckLeftWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var FoodTruckRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
var CoffebarRightWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject12(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("sm");
});

;// CONCATENATED MODULE: ./src/static_pages/components/HeroImages.js





var keywords = {
    vegan: {
        wrappers: [
            VeganLeftWrapper,
            VeganRightWrapper
        ],
        left: {
            width: 290,
            height: 215
        },
        right: {
            width: 270,
            height: 180
        }
    },
    breakfast: {
        wrappers: [
            BaseLeftWrapper,
            BaseRightWrapper
        ],
        left: {
            width: 250,
            height: 250
        },
        right: {
            width: 216,
            height: 300
        }
    },
    hero: {
        wrappers: [
            HeroLeftWrapper,
            HeroRightWrapper
        ],
        left: {
            width: 500,
            height: 430
        },
        right: {
            width: 200,
            height: 455.23520485584
        }
    },
    dessert: {
        wrappers: [
            BaseLeftWrapper,
            BaseRightWrapper
        ],
        left: {
            width: 300,
            height: 297
        },
        right: {
            width: 300,
            height: 285
        }
    },
    event: {
        wrappers: [
            BaseLeftWrapper,
            BaseRightWrapper
        ],
        left: {
            width: 240,
            height: 324
        },
        right: {
            width: 300,
            height: 270
        }
    },
    buffet: {
        wrappers: [
            BaseLeftWrapper,
            BaseRightWrapper
        ],
        left: {
            width: 300,
            height: 303
        },
        right: {
            width: 300,
            height: 220
        }
    },
    fingerfood: {
        wrappers: [
            FingerFoodLeftWrapper,
            FingerFoodRightWrapper
        ],
        left: {
            width: 350,
            height: 144
        },
        right: {
            width: 240,
            height: 220
        }
    },
    foodtruck: {
        wrappers: [
            FoodTruckLeftWrapper,
            FoodTruckRightWrapper
        ],
        left: {
            width: 300,
            height: 149
        },
        right: {
            width: 300,
            height: 329
        }
    },
    "lunch-dinner": {
        wrappers: [
            BaseLeftWrapper,
            BaseRightWrapper
        ],
        left: {
            width: 300,
            height: 263
        },
        right: {
            width: 300,
            height: 201
        }
    },
    cocktailbar: {
        wrappers: [
            CocktailLeftWrapper,
            CocktailRightWrapper
        ],
        left: {
            width: 250,
            height: 292
        },
        right: {
            width: 280,
            height: 217
        }
    },
    coffebar: {
        wrappers: [
            CocktailLeftWrapper,
            CoffebarRightWrapper
        ],
        left: {
            width: 270,
            height: 225
        },
        right: {
            width: 260,
            height: 251
        }
    },
    bbq: {
        wrappers: [
            BaseLeftWrapper,
            BaseRightWrapper
        ],
        left: {
            width: 280,
            height: 299
        },
        right: {
            width: 280,
            height: 234
        }
    }
};
function HeroImages(param) {
    var keyword = param.keyword;
    var keywordImages = keywords[keyword];
    var _wrappers = (0,_sliced_to_array/* default */.Z)(keywordImages.wrappers, 2), LeftWrapper = _wrappers[0], RightWrapper = _wrappers[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: "/artifacts/images/homepage/".concat(keyword, "-left-site.webp"),
                    width: keywordImages.left.width,
                    height: keywordImages.left.height,
                    layout: "intrinsic"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: "/artifacts/images/homepage/".concat(keyword, "-right-site.webp"),
                    width: keywordImages.right.width,
                    height: keywordImages.right.height,
                    layout: "intrinsic"
                })
            })
        ]
    });
}
/* harmony default export */ var components_HeroImages = (HeroImages);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/components/Hero.js

function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        ";\n  position: relative;\n  overflow: hidden;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: ",
        "px;\n  left: 50%;\n  margin-left: ",
        "px;\n  transform: translateX(-50%);\n  max-width: 650px;\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











function Hero(param) {
    var title = param.title, subtitle = param.subtitle, _virtualEvent = param.virtualEvent, virtualEvent = _virtualEvent === void 0 ? false : _virtualEvent, cityFromSlug = param.cityFromSlug, _keywords = param.keywords, keywords = _keywords === void 0 ? [] : _keywords, _term = param.term, term = _term === void 0 ? "" : _term;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var fromTabletDown = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var fromDesktopUp = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var keyword = keywords[0] || "hero";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeroImages, {
                        keyword: keyword
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                size: "sm",
                                children: function() {
                                    if (title) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                            variant: "h1",
                                            children: title
                                        });
                                    }
                                    if (virtualEvent) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Typography */.ZT, {
                                            variant: "h1",
                                            children: [
                                                t("virtualEventsHero.title.a"),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                    variant: "inherit",
                                                    slab: "true",
                                                    color: "secondary",
                                                    children: t("virtualEventsHero.title.b")
                                                })
                                            ]
                                        });
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "h1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                            t: t,
                                            i18nKey: "baseHero.title",
                                            components: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}, "span")
                                            ]
                                        })
                                    });
                                }()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                size: "xs",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                    variant: "subtitle2",
                                    color: "textSecondary",
                                    mt: 4,
                                    mb: 4,
                                    children: function() {
                                        if (subtitle) return subtitle;
                                        if (virtualEvent) return t("virtualEventsHero.subtitle");
                                        return t("baseHero.subtitle");
                                    }()
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                pl: 2,
                                pr: 2,
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                children: function() {
                                    if (virtualEvent) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                                            size: "lg",
                                            rounded: true,
                                            as: "a",
                                            href: (0,urls/* marketplaceURL */.j5)("/catering/virtual_events"),
                                            children: t("common:labels.findVirtualEvents")
                                        });
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        width: "100%",
                                        maxWidth: "500px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelector/* default */.Z, {
                                            width: "100%",
                                            cityFromSlug: cityFromSlug,
                                            cateringCategories: keywords,
                                            term: term
                                        })
                                    });
                                }()
                            })
                        ]
                    }),
                    fromDesktopUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomersTrustElement, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "",
                            src: "/artifacts/images/homepage/hero-customers-trust-element@4x.webp",
                            width: 2476,
                            height: 134
                        })
                    })
                ]
            }),
            fromTabletDown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    pt: 2,
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        src: "/artifacts/images/homepage/hero-customers-trust-element@4x.webp",
                        width: 619,
                        height: 34
                    })
                })
            })
        ]
    });
}
var MainWrapper = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject(), function(props) {
    return props.theme.colors.heroGradient;
}, function(props) {
    return props.theme.spacing(10, 0, 14);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(6, 0, 20);
});
var HeroContent = styled_components_browser_esm/* default.header */.ZP.header(Hero_templateObject1());
var CustomersTrustElement = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject2(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(1);
});
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/static_pages/components/MarketplaceHero.js

function MarketplaceHero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    MarketplaceHero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MarketplaceHero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"
    ]);
    MarketplaceHero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MarketplaceHero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n"
    ]);
    MarketplaceHero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







function MarketplaceHero_Hero(param) {
    var title = param.title, subtitle = param.subtitle;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceHero_MainWrapper, {
            py: 5,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceHero_HeroContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    size: "sm",
                    children: [
                        title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "h2",
                            component: "h1",
                            children: title
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "h2",
                            component: "h1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                t: t,
                                i18nKey: "baseHero.title",
                                components: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}, "span")
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "subtitle2",
                            color: "textSecondary",
                            mt: 2,
                            children: subtitle ? subtitle : t("baseHero.subtitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            rounded: true,
                            size: "lg",
                            onClick: function() {
                                return router.push("/start");
                            },
                            id: "seo-berlin-qual-survey",
                            children: t("baseHero.cta")
                        })
                    ]
                })
            })
        })
    });
}
var MarketplaceHero_MainWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(MarketplaceHero_templateObject(), function(props) {
    return props.theme.colors.heroGradient;
});
var MarketplaceHero_HeroContent = styled_components_browser_esm/* default.header */.ZP.header(MarketplaceHero_templateObject1());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(MarketplaceHero_templateObject2(), function(props) {
    return props.theme.spacing(7, 0, 3);
}, function(props) {
    return props.theme.spacing(8);
}, function(props) {
    return props.theme.spacing(8);
});
/* harmony default export */ var MarketplaceHero = (MarketplaceHero_Hero);

// EXTERNAL MODULE: ./src/shared/components/Accordion.js
var Accordion = __webpack_require__(31555);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/Faqs.js






function Faqs(param) {
    var faqs = param.faqs, faqHeadline = param.faqHeadline;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        as: "section",
        mb: 4,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            size: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "h3",
                        mt: 4,
                        mb: 6,
                        component: "h2",
                        children: faqHeadline
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    children: faqs.map(function(faq) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion["default"], {
                            summary: faq.fields.question,
                            details: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(faq.fields.answer)
                        }, faq.objectID);
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_Faqs = (Faqs);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/FindVirtualEventsButton.js







function FindVirtualEventsButton(props) {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        size: "md",
        as: "a",
        href: (0,urls/* marketplaceURL */.j5)("/catering/virtual_events")
    }, props), {
        children: t("common:labels.findVirtualEvents")
    }));
}
/* harmony default export */ var components_FindVirtualEventsButton = (FindVirtualEventsButton);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/HowItWorksCTA.tsx
var HowItWorksCTA = __webpack_require__(4775);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/PartnersCTA.js + 1 modules
var PartnersCTA = __webpack_require__(24085);
// EXTERNAL MODULE: ./src/hub/components/ContentfulImage.js
var ContentfulImage = __webpack_require__(79635);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/SearchLandingPageImage.js

function SearchLandingPageImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  border-radius: 8px;\n"
    ]);
    SearchLandingPageImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var calculateRatioPreservedHeight = function(param) {
    var width = param.width, originalWidth = param.originalWidth, originalHeight = param.originalHeight;
    return Math.round(originalHeight / originalWidth * width);
};
function SearchLandingPageImage(param) {
    var fields = param.fields;
    var originalWidth = fields.file.details.image.width;
    var originalHeight = fields.file.details.image.height;
    var width = 720;
    var height = calculateRatioPreservedHeight({
        width: width,
        originalWidth: originalWidth,
        originalHeight: originalHeight
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulImage["default"], {
            alt: fields.title,
            width: width,
            height: height,
            src: {
                fields: fields
            },
            layout: "responsive"
        })
    });
}
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(SearchLandingPageImage_templateObject());
/* harmony default export */ var components_SearchLandingPageImage = (SearchLandingPageImage);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/SearchLandingPageSection.js







function SearchLandingPageSection(param) {
    var title = param.title, image = param.image, body = param.body;
    var ref, ref1;
    var formattedBody = body && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, (0,contentful/* embeddedAssetOptions */.k)((ref = body.links) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1.block));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "h4",
                    mt: 4,
                    mb: 4,
                    children: title
                })
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchLandingPageImage, (0,src_object_spread/* default */.Z)({}, image)),
            body && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                children: formattedBody
            })
        ]
    });
}
/* harmony default export */ var components_SearchLandingPageSection = (SearchLandingPageSection);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/SidebarCTA.js
var SidebarCTA = __webpack_require__(84332);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/index.js + 1 modules
var TopCaterers = __webpack_require__(36926);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/SearchLandingPage.js
























function SearchLandingPage(param) {
    var page = param.page, ratings = param.ratings;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var router = (0,next_router.useRouter)();
    var cityMapping = (0,cities/* cityMappingByLocale */.HL)(router.locale);
    var displayMarketplaceHero = page.cityFromSlug === cityMapping["berlin"] && !page.virtualEventPage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        renderNavbarCta: page.virtualEventPage ? function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FindVirtualEventsButton, {
                size: "md"
            });
        } : null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: page.pageTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: page.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: page.pageTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: page.metaDescription
                    }),
                    page.faQsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify((0,helpers/* buildFaqMarkup */.bB)(page.faQs))
                        }
                    })
                ]
            }),
            displayMarketplaceHero ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketplaceHero, {
                title: page.heroTitle || page.pageTitle,
                subtitle: page.heroSubtitle
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {
                title: page.heroTitle || page.pageTitle,
                subtitle: page.heroSubtitle,
                virtualEvent: page.virtualEventPage,
                keywords: page.keywords,
                cityFromSlug: page.cityFromSlug,
                term: page.topCaterersSearchTerm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterers/* default */.Z, {
                topCaterers: page.topCaterers,
                title: page.topCaterersTitle,
                city: page.topCaterersSearchCity,
                term: page.topCaterersSearchTerm,
                keywords: page.keywords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                pt: 4,
                pb: 4,
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarCTA/* AreaWithSidebarCTA */.U, {
                        title: page.virtualEventPage && t("virtualEventsHero.titleAlt"),
                        subtitle: page.virtualEventPage && t("virtualEventsHero.subtitle"),
                        ctaText: page.virtualEventPage && t("common:labels.findVirtualEvents"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                            size: "xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchLandingPageSection, {
                                    title: page.section1Header,
                                    image: page.section1Image,
                                    body: page.section1Body
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchLandingPageSection, {
                                    title: page.section2Header,
                                    image: page.section2Image,
                                    body: page.section2Body
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchLandingPageSection, {
                                    title: page.section3Header,
                                    image: page.section3Image,
                                    body: page.section3Body
                                })
                            ]
                        })
                    }),
                    page.faQsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        px: 5,
                        pb: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Faqs, {
                            faqs: page.faQs,
                            faqHeadline: page.faqSectionHeadline
                        })
                    })
                ]
            }),
            !page.virtualEventPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        pt: 4,
                        pb: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksCTA/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersCTA/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAWithBenefits/* default */.Z, {
                containerSize: "sm",
                virtualEvent: page.virtualEventPage,
                cityFromSlug: page.cityFromSlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks["default"], {
                pb: {
                    xs: 2,
                    sm: 6
                },
                pt: {
                    xs: 2,
                    sm: 3
                }
            })
        ]
    });
}
function getStaticProps() {
    return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
    _getStaticProps = _async_to_generator(function() {
        var ratings;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchRatings()
                    ];
                case 1:
                    ratings = _state.sent();
                    return [
                        2,
                        {
                            props: {
                                robots: "none",
                                ratings: ratings
                            }
                        }
                    ];
            }
        });
    });
    return _getStaticProps.apply(this, arguments);
}
/* harmony default export */ var components_SearchLandingPage = (SearchLandingPage);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/country_landing_page/components/CountryImage.js

function CountryImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  border-radius: ",
        "px;\n"
    ]);
    CountryImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function CountryImage(param) {
    var fields = param.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryImage_ImageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulImage["default"], {
            alt: fields.title,
            width: 379,
            height: 210,
            src: {
                fields: fields
            },
            layout: "responsive"
        })
    });
}
var CountryImage_ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(CountryImage_templateObject(), function(props) {
    return props.theme.spacing(1.5);
});
/* harmony default export */ var components_CountryImage = (CountryImage);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/country_landing_page/components/CountryListing.js

function CountryListing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: inherit;\n  color: inherit;\n  cursor: pointer;\n"
    ]);
    CountryListing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CountryListing_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);\n  text-align: center;\n  border-radius: ",
        "px;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    CountryListing_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function CountryListing(param) {
    var cities = param.cities;
    var sortedCities = cities.map(function(x) {
        return x.fields.name.trim();
    }).sort();
    var groupCities = function() {
        var groupCitiesByLetter = sortedCities.reduce(function(acc, value) {
            var char = value.charAt(0).toUpperCase();
            acc[char] = [].concat(acc[char] || [], value);
            return acc;
        }, {});
        var citiesWithLetter = Object.keys(groupCitiesByLetter).map(function(el) {
            return {
                letter: el,
                cities: groupCitiesByLetter[el]
            };
        });
        return citiesWithLetter;
    };
    var citiesGroupedByLetter = groupCities();
    var alpha = Array.from(Array(26)).map(function(e, i) {
        return i + 65;
    });
    var alphabet = alpha.map(function(x) {
        return String.fromCharCode(x);
    });
    var findSlugByCity = function(cityName) {
        return cities.find(function(city) {
            return city.fields.name.trim() === cityName;
        }).fields.slug;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: alphabet.map(function(letter) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "h4",
                        py: 4,
                        children: letter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        container: true,
                        spacing: 4,
                        children: (((ref = citiesGroupedByLetter.find(function(x) {
                            return x.letter === letter;
                        })) === null || ref === void 0 ? void 0 : ref.cities) || []).map(function(city) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                item: true,
                                lg: 6,
                                md: 6,
                                sm: 6,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                    href: "/catering-".concat(findSlugByCity(city)),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                            variant: "h6",
                                            children: city
                                        })
                                    })
                                })
                            }, city.objectID);
                        })
                    })
                ]
            });
        })
    });
}
var StyledLink = styled_components_browser_esm/* default.a */.ZP.a(CountryListing_templateObject());
var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(CountryListing_templateObject1(), function(props) {
    return props.theme.spacing(2, 4);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.text.disabled;
});
/* harmony default export */ var components_CountryListing = (CountryListing);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/country_landing_page/components/Hero.js

function components_Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: ",
        ";\n  position: relative;\n  overflow: hidden;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    components_Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function components_Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n"
    ]);
    components_Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function Hero_Hero(param) {
    var title = param.title, subtitle = param.subtitle, cityFromSlug = param.cityFromSlug;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_MainWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_HeroContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        size: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        size: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "subtitle2",
                            mt: 4,
                            mb: 4,
                            children: subtitle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        pl: 2,
                        pr: 2,
                        width: "100%",
                        display: "flex",
                        maxWidth: 600,
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CitySelector/* default */.Z, {
                            cityFromSlug: cityFromSlug,
                            buttonLabelKey: "common:labels.findCatering"
                        })
                    })
                ]
            })
        })
    });
}
var Hero_MainWrapper = styled_components_browser_esm/* default.div */.ZP.div(components_Hero_templateObject(), function(props) {
    return props.theme.colors.heroGradient;
}, function(props) {
    return props.theme.spacing(10, 0, 10);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(6, 0, 6);
});
var Hero_HeroContent = styled_components_browser_esm/* default.header */.ZP.header(components_Hero_templateObject1());
/* harmony default export */ var country_landing_page_components_Hero = (Hero_Hero);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 12 modules
var TextField = __webpack_require__(77269);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 5 modules
var Autocomplete = __webpack_require__(26270);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/country_landing_page/components/SearchBar.js



function SearchBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: ",
        "px;\n  color: #9e9e9e;\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiInputBase-root {\n    border-radius: ",
        "px;\n  }\n"
    ]);
    SearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function SearchBar(param) {
    var cities = param.cities;
    var router = (0,next_router.useRouter)();
    var citiesWithSlug = cities.map(function(city) {
        return {
            name: city.fields.name,
            slug: city.fields.slug
        };
    });
    var handleChange = function(event, newValue) {
        router.push("/catering-".concat(newValue.slug));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
            onChange: handleChange,
            options: citiesWithSlug,
            getOptionLabel: function(option) {
                var ref;
                return (ref = option.name) === null || ref === void 0 ? void 0 : ref.toString();
            },
            renderInput: function(params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params), {
                    color: "primary",
                    margin: "dense",
                    variant: "outlined",
                    placeholder: "Search",
                    InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params.InputProps), {
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchIcon, {}),
                        endAdornment: null
                    })
                }));
            },
            style: {
                width: 300
            }
        })
    });
}
var StyledSearchIcon = (0,styled_components_browser_esm/* default */.ZP)(Search/* default */.Z)(SearchBar_templateObject(), function(props) {
    return props.theme.spacing(1);
});
var StyledTextField = (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z)(SearchBar_templateObject1(), function(props) {
    return props.theme.spacing(3.5);
});
/* harmony default export */ var components_SearchBar = (SearchBar);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/country_landing_page/components/TextSection.js

function TextSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    TextSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function TextSection(param) {
    var body = param.body;
    var ref, ref1;
    var formattedBody = body && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, (0,contentful/* embeddedAssetOptions */.k)((ref = body.links) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1.block));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: body && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSection_StyledBox, {
            children: formattedBody
        })
    });
}
var TextSection_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(TextSection_templateObject(), function(props) {
    return props.theme.palette.primary.main;
});
/* harmony default export */ var components_TextSection = (TextSection);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/country_landing_page/index.js





















function CountryLandingPage(param) {
    var page = param.page, ratings = param.ratings;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: page.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: page.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: page.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: page.metaDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(country_landing_page_components_Hero, {
                title: page.heroTitle,
                subtitle: page.heroSubtitle,
                cityFromSlug: page.cityFromSlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarCTA/* AreaWithSidebarCTA */.U, {
                title: t("marketingPages.sidebar.title"),
                subtitle: t("marketingPages.sidebar.body"),
                ctaText: t("marketingPages.sidebar.cta"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    size: "xs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            pt: {
                                xs: 2,
                                md: 6
                            },
                            pb: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextSection, {
                                body: page.section1Body
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            pb: 3,
                            children: page.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CountryImage, (0,src_object_spread/* default */.Z)({}, page.image))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            display: "flex",
                            justifyContent: {
                                xs: "center",
                                sm: "flex-end"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SearchBar, {
                                cities: page.cityList
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            pb: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CountryListing, {
                                cities: page.cityList,
                                slug: page.slug
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            pb: 2,
                            pt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TextSection, {
                                body: page.section2Body
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        pb: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksCTA/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnersCTA/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAWithBenefits/* default */.Z, {
                containerSize: "sm"
            })
        ]
    });
}
function country_landing_page_getStaticProps() {
    return marketing_pages_country_landing_page_getStaticProps.apply(this, arguments);
}
function marketing_pages_country_landing_page_getStaticProps() {
    marketing_pages_country_landing_page_getStaticProps = _async_to_generator(function() {
        var ratings;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchRatings()
                    ];
                case 1:
                    ratings = _state.sent();
                    return [
                        2,
                        {
                            props: {
                                robots: "none",
                                ratings: ratings
                            }
                        }
                    ];
            }
        });
    });
    return marketing_pages_country_landing_page_getStaticProps.apply(this, arguments);
}
/* harmony default export */ var country_landing_page = (CountryLandingPage);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/FooterClean.js
var FooterClean = __webpack_require__(23288);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/SectionImage.js

function SectionImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  border-radius: ",
        "px;\n"
    ]);
    SectionImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function SectionImage(param) {
    var fields = param.fields, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionImage_ImageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulImage["default"], {
            alt: fields.title,
            width: width,
            height: height,
            src: {
                fields: fields
            },
            layout: "responsive"
        })
    });
}
var SectionImage_ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(SectionImage_templateObject(), function(props) {
    return props.theme.spacing(1.5);
});
/* harmony default export */ var components_SectionImage = (SectionImage);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/PageSectionA.js


function PageSectionA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n\n  ",
        " {\n    align-self: center;\n  }\n"
    ]);
    PageSectionA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSectionA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n"
    ]);
    PageSectionA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PageSectionA_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n\n  ",
        " {\n    margin: ",
        ";\n  }\n\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    PageSectionA_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








function PageSectionA(param) {
    var body = param.body, image = param.image, header = param.header;
    var ref, ref1;
    var formattedBody = body && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, (0,contentful/* embeddedAssetOptions */.k)((ref = body.links) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1.block));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGridContainer, {
            container: true,
            spacing: {
                xs: 0,
                sm: 2
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridLeft, {
                    item: true,
                    xs: 0,
                    sm: 4,
                    children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionImage, (0,src_object_spread/* default */.Z)({
                        width: 408,
                        height: 373
                    }, image))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGridRight, {
                    item: true,
                    xs: 12,
                    sm: 7,
                    md: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "h3",
                            pb: {
                                xs: 1,
                                sm: 3
                            },
                            pl: {
                                sm: 3
                            },
                            mt: 2,
                            textAlign: {
                                xs: "center",
                                sm: "left"
                            },
                            children: header
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "body1",
                            pl: {
                                xs: 0,
                                sm: 3
                            },
                            children: body && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                children: formattedBody
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var StyledGridLeft = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(PageSectionA_templateObject(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var StyledGridRight = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(PageSectionA_templateObject1());
var StyledGridContainer = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(PageSectionA_templateObject2(), function(props) {
    return props.theme.spacing(7, 0, 8, 0);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(7, 2, 4, 0);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(3, 0, 3, 0);
});
/* harmony default export */ var components_PageSectionA = (PageSectionA);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/PageSectionB.js


function PageSectionB_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: ",
        "px;\n\n  ",
        " {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    PageSectionB_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSectionB_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    PageSectionB_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function PageSectionB(param) {
    var header = param.header, content = param.content, cta = param.cta, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        mb: {
            xs: 6,
            sm: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                textAlign: "center",
                px: {
                    xs: 0,
                    sm: 15,
                    md: 12
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "h3",
                    mt: 4,
                    mb: 6,
                    xs: {
                        lineHeight: 1.5
                    },
                    children: header
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                container: true,
                spacing: {
                    xs: 0,
                    sm: 2
                },
                children: content.map(function(contentPart) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGridItem, {
                        item: true,
                        md: 6,
                        sm: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                width: 117,
                                pb: 3,
                                m: {
                                    xs: "auto",
                                    sm: 0
                                },
                                children: contentPart.fields.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionImage, (0,src_object_spread/* default */.Z)({
                                    width: 408,
                                    height: 373
                                }, contentPart.fields.image))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h5",
                                pb: 2,
                                children: contentPart.fields.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                pr: {
                                    xs: 0,
                                    md: 8
                                },
                                children: contentPart.fields.body
                            })
                        ]
                    }, content.objectID);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mt: {
                    xs: 3,
                    sm: 5
                },
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                    size: "lg",
                    rounded: true,
                    as: "a",
                    href: link,
                    target: "_blank",
                    children: cta
                })
            })
        ]
    });
}
var StyledGrid = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(PageSectionB_templateObject(), function(props) {
    return props.theme.spacing(6);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(1);
});
var StyledGridItem = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(PageSectionB_templateObject1(), function(props) {
    return props.theme.spacing(2, 0);
});
/* harmony default export */ var components_PageSectionB = (PageSectionB);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/PageSectionC.js


function PageSectionC_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: center;\n"
    ]);
    PageSectionC_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function PageSectionC(param) {
    var header = param.header, subtitle = param.subtitle, content = param.content, cta = param.cta, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        mb: {
            xs: 6,
            sm: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                textAlign: "center",
                px: {
                    xs: 0,
                    sm: 5,
                    md: 12
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "h3",
                        mt: 4,
                        px: {
                            xs: 0,
                            sm: 5,
                            md: 0
                        },
                        xs: {
                            lineHeight: 1.5
                        },
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "body1",
                        mt: 3,
                        mb: 6,
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSectionC_StyledGrid, {
                container: true,
                spacing: {
                    xs: 0,
                    sm: 2
                },
                children: content.map(function(contentPart) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        item: true,
                        md: 4,
                        sm: 6,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h5",
                                pb: 2,
                                textAlign: "center",
                                children: contentPart.fields.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                pb: 2,
                                width: "350px",
                                margin: "0 auto",
                                children: contentPart.fields.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionImage, (0,src_object_spread/* default */.Z)({
                                    width: 379,
                                    height: 253
                                }, contentPart.fields.image))
                            })
                        ]
                    }, content.objectID);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mt: {
                    xs: 3,
                    sm: 5
                },
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                    size: "lg",
                    rounded: true,
                    id: "sectionC-button",
                    as: "a",
                    href: link,
                    target: "_blank",
                    children: cta
                })
            })
        ]
    });
}
var PageSectionC_StyledGrid = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(PageSectionC_templateObject());
/* harmony default export */ var components_PageSectionC = (PageSectionC);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/SocialProofBar.js

function SocialProofBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    SocialProofBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SocialProofBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f8f8f8;\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    SocialProofBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SocialProofBar_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 21%;\n\n  ",
        " {\n    width: 33%;\n  }\n\n  ",
        " {\n    width: 100%;\n    display: flex;\n  }\n"
    ]);
    SocialProofBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function SocialProofBar() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialProofBar_StyledBox, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialProofContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialProofItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "",
                            src: "/artifacts/images/marketing_pages/socialProofBar-platform.webp",
                            width: 54,
                            height: 54
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            flex: 1,
                            px: 2,
                            py: {
                                xs: 2,
                                sm: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                pr: 1,
                                children: t("socialProofBar.text1")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialProofItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                src: "/artifacts/images/marketing_pages/socialProofBar-customer.webp",
                                width: 54,
                                height: 54
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            flex: 1,
                            px: 2,
                            py: {
                                xs: 2,
                                sm: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                pr: {
                                    xs: 0,
                                    md: 1.5
                                },
                                children: t("socialProofBar.text2")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialProofItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                src: "/artifacts/images/marketing_pages/socialProofBar-partner.webp",
                                width: 54,
                                height: 54
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            flex: 1,
                            px: 2,
                            py: {
                                xs: 4,
                                sm: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                pr: {
                                    xs: 1,
                                    md: 3
                                },
                                children: t("socialProofBar.text3")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialProofItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                src: "/artifacts/images/marketing_pages/socialProofBar-stars.webp",
                                width: 54,
                                height: 54
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            flex: 1,
                            px: 2,
                            py: {
                                xs: 2,
                                sm: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                pr: 1,
                                children: t("socialProofBar.text4")
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function IconWrapper(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        children: children
    });
}
var SocialProofContent = styled_components_browser_esm/* default.div */.ZP.div(SocialProofBar_templateObject(), function(props) {
    return props.theme.breakpoints.down("xs");
});
var SocialProofBar_StyledBox = styled_components_browser_esm/* default.div */.ZP.div(SocialProofBar_templateObject1(), function(props) {
    return props.theme.spacing(1.5, 3, 1, 8);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(2, 0, 2, 3);
});
var SocialProofItem = styled_components_browser_esm/* default.div */.ZP.div(SocialProofBar_templateObject2(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
/* harmony default export */ var components_SocialProofBar = (SocialProofBar);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(1197);
// EXTERNAL MODULE: ./node_modules/react-swipeable/es/index.js
var es = __webpack_require__(45338);
// EXTERNAL MODULE: ./src/static_pages/home/components/svg/QuotationMark.js
var QuotationMark = __webpack_require__(57844);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/TestimonialImage.js

function TestimonialImage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: relative;\n  border-radius: 500px;\n"
    ]);
    TestimonialImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function TestimonialImage(param) {
    var fields = param.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialImage_ImageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulImage["default"], {
            alt: fields.title,
            width: 176,
            height: 176,
            src: {
                fields: fields
            },
            layout: "responsive",
            objectFit: "cover"
        })
    });
}
var TestimonialImage_ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(TestimonialImage_templateObject());
/* harmony default export */ var components_TestimonialImage = (TestimonialImage);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/Testimonials.js



function Testimonials_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  cursor: pointer;\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    align-self: flex-end;\n    padding-top: ",
        "px;\n  }\n"
    ]);
    Testimonials_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function PartnerQuotes(param) {
    var content = param.content, header = param.header;
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,react.useState)(0), currentQuote = ref[0], setCurrentQuote = ref[1];
    var ref1 = (0,react.useState)(content[0]), contentPart = ref1[0], setContent = ref1[1];
    var back = function() {
        if (currentQuote > 0) {
            var contentIndex = currentQuote - 1;
            setCurrentQuote(contentIndex);
            setContent(content[contentIndex]);
        } else {
            setCurrentQuote(content.length - 1);
            setContent(content[content.length - 1]);
        }
    };
    var swipeHandlers = (0,es/* useSwipeable */.QS)({
        onSwiped: function(param) {
            var dir = param.dir;
            if (dir === "Left") {
                next();
            }
            if (dir === "Right") {
                back();
            }
        }
    });
    var next = function() {
        if (currentQuote < content.length - 1) {
            var contentIndex = currentQuote + 1;
            setCurrentQuote(contentIndex);
            setContent(content[contentIndex]);
        } else {
            setCurrentQuote(0);
            setContent(content[0]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, swipeHandlers), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "h3",
                    mt: {
                        xs: 6,
                        sm: 10
                    },
                    xs: {
                        lineHeight: 1.5
                    },
                    px: {
                        sm: 15,
                        md: 10
                    },
                    children: header
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: {
                    xs: "column",
                    md: "row"
                },
                mt: 5,
                mb: {
                    xs: 0,
                    md: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        display: "flex",
                        flexDirection: {
                            xs: "row",
                            md: "column"
                        },
                        alignItems: "center",
                        minWidth: 176,
                        mr: {
                            xs: 0,
                            md: 8
                        },
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                position: "relative",
                                width: {
                                    xs: 118,
                                    md: 176
                                },
                                height: {
                                    xs: 118,
                                    md: 176
                                },
                                border: "solid 4px",
                                borderColor: theme.palette.text.disabled,
                                borderRadius: 500,
                                children: contentPart.fields.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TestimonialImage, (0,src_object_spread/* default */.Z)({}, contentPart.fields.image))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                textAlign: {
                                    xs: "left",
                                    md: "center"
                                },
                                ml: {
                                    xs: 4,
                                    md: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "subtitle1",
                                        mt: {
                                            xs: 0,
                                            sm: 4
                                        },
                                        children: contentPart.fields.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "caption",
                                        children: contentPart.fields.company
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        position: "relative",
                        mr: {
                            xs: 3,
                            md: 9
                        },
                        ml: {
                            xs: 3,
                            md: 0
                        },
                        flexGrow: 2,
                        mt: {
                            xs: 5,
                            md: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "subtitle2",
                                mb: 4,
                                children: contentPart.fields.body
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                position: "absolute",
                                bottom: 4,
                                right: 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMark/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Testimonials_StyledBox, {
                        mb: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                onClick: back,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
                                    color: "disabled",
                                    fontSize: "large"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                onClick: next,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                    fontSize: "large"
                                })
                            })
                        ]
                    })
                ]
            }, contentPart.fields.name)
        ]
    }));
}
var Testimonials_StyledBox = styled_components_browser_esm/* default.div */.ZP.div(Testimonials_templateObject(), function(props) {
    return props.theme.spacing(4);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ var Testimonials = (PartnerQuotes);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/TrustedCustomers.js

function TrustedCustomers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n"
    ]);
    TrustedCustomers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TrustedCustomers_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: rgba(248, 248, 248, 1);\n"
    ]);
    TrustedCustomers_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function TrustedCustomers(param) {
    var title = param.title;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                textAlign: "center",
                variant: mobile ? "h4" : "h3",
                xs: {
                    lineHeight: 1.5
                },
                px: {
                    xs: 4,
                    sm: 10,
                    md: 0
                },
                component: "p",
                children: title ? t(title) : t("baseHero.trustedBy")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                pt: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: {
                    xs: "wrap",
                    md: "nowrap"
                },
                width: {
                    xs: 400,
                    md: "100%"
                },
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mx: {
                            xs: 4,
                            lg: 5
                        },
                        my: 2,
                        width: {
                            xs: 74,
                            md: 127
                        },
                        height: {
                            xs: 14,
                            md: 20
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogo, {
                            alt: "The logo of Barmer",
                            src: "/artifacts/images/homepage/trust-customer-icons/barmer.webp",
                            layout: "responsive",
                            width: "127",
                            height: "20"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mx: {
                            xs: 4,
                            lg: 5
                        },
                        my: 2,
                        width: {
                            xs: 35,
                            md: 46
                        },
                        height: {
                            xs: 35,
                            md: 46
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogo, {
                            alt: "The logo of Dell",
                            src: "/artifacts/images/homepage/trust-customer-icons/dell.webp",
                            layout: "responsive",
                            width: "46",
                            height: "46"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mx: {
                            xs: 4,
                            lg: 5
                        },
                        my: 2,
                        width: {
                            xs: 67,
                            md: 103
                        },
                        height: {
                            xs: 12,
                            md: 25
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogo, {
                            alt: "The logo of Infarm",
                            src: "/artifacts/images/homepage/trust-customer-icons/infarm.webp",
                            layout: "responsive",
                            width: "103",
                            height: "25"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mx: {
                            xs: 4,
                            lg: 5
                        },
                        my: 2,
                        width: 62,
                        height: {
                            xs: 13,
                            md: 25
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogo, {
                            alt: "The logo of Ebay",
                            src: "/artifacts/images/homepage/trust-customer-icons/ebay.webp",
                            layout: "responsive",
                            width: "62",
                            height: "25"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mx: {
                            xs: 4,
                            lg: 5
                        },
                        my: 2,
                        width: {
                            xs: 44,
                            md: 66
                        },
                        height: {
                            xs: 22,
                            md: 32
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogo, {
                            alt: "The logo of Hellofresh",
                            src: "/artifacts/images/homepage/trust-customer-icons/hellofresh.webp",
                            layout: "responsive",
                            width: "66",
                            height: "32"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mx: {
                            xs: 4,
                            lg: 5
                        },
                        my: 2,
                        width: {
                            xs: 47,
                            md: 56
                        },
                        height: {
                            xs: 9,
                            md: 20
                        },
                        position: "relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerLogo, {
                            alt: "The logo of Audi",
                            src: "/artifacts/images/homepage/trust-customer-icons/audi.webp",
                            layout: "responsive",
                            width: "56",
                            height: "20"
                        })
                    })
                ]
            })
        ]
    });
}
var CustomerLogo = (0,styled_components_browser_esm/* default */.ZP)((image_default()))(TrustedCustomers_templateObject(), function(props) {
    return props.theme.spacing(0, 10);
});
var StyledContainer = styled_components_browser_esm/* default.div */.ZP.div(TrustedCustomers_templateObject1(), function(props) {
    return props.theme.spacing(4, 0);
});
/* harmony default export */ var components_TrustedCustomers = (TrustedCustomers);

// EXTERNAL MODULE: ./src/shared/components/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(21890);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForward.js
var ArrowForward = __webpack_require__(29973);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOn.js
var LocationOn = __webpack_require__(59832);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/useAutocomplete/useAutocomplete.js
var useAutocomplete = __webpack_require__(11514);
// EXTERNAL MODULE: ./src/shared/hooks/useCities.ts
var useCities = __webpack_require__(77976);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/customer_landing_page/components/IntlCitySelector.js



function IntlCitySelector_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: -0.5px;\n  top: 50%;\n  transform: translateY(-50%);\n"
    ]);
    IntlCitySelector_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IntlCitySelector_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 0 500px 500px 0;\n  padding: 16.5px ",
        "px;\n  height: 56px; // Same as the input field\n\n  ",
        " {\n    padding: 19.5px ",
        "px;\n  }\n\n  svg {\n    font-size: 1rem;\n  }\n"
    ]);
    IntlCitySelector_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IntlCitySelector_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  display: flex;\n  box-shadow: 0 4px 40px rgba(62, 41, 29, 0.1);\n  border-radius: 500px;\n  position: relative;\n  transition: ",
        ";\n  z-index: 1;\n  margin: 0 auto;\n\n  ",
        " {\n    margin: ",
        ";\n  }\n  ",
        " {\n    margin: ",
        ";\n  }\n\n  &:hover {\n    box-shadow: 0 4px 50px rgba(62, 41, 29, 0.15);\n  }\n"
    ]);
    IntlCitySelector_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function IntlCitySelector_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  position: relative;\n"
    ]);
    IntlCitySelector_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function IntlCitySelector_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 14px;\n  top: 14px;\n  z-index: 1;\n"
    ]);
    IntlCitySelector_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function IntlCitySelector_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  padding: ",
        ";\n  border-radius: 500px;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    IntlCitySelector_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











function IntlCitySelector(param) {
    var _width = param.width, width = _width === void 0 ? "800px" : _width, _buttonLabelKey = param.buttonLabelKey, buttonLabelKey = _buttonLabelKey === void 0 ? "common:labels.findCaterers" : _buttonLabelKey, redirectURL = param.redirectURL;
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,useCities/* default */.Z)(), cities = ref.cities, cityNames = ref.cityNames, cityKeys = ref.cityKeys;
    var fromTabletDown = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var ref1 = (0,react.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    var handleRedirect = function() {
        router.push(redirectURL);
    };
    var handleAutocompleteSelection = function(event, city) {
        var cityKey = cityKeys.find(function(cityKey) {
            return cities[cityKey] === city;
        });
        if (cityKey) {
            handleRedirect();
        }
    };
    var handleFindCaterersSelection = function() {
        handleRedirect();
    };
    var filterOptions = (0,useAutocomplete/* createFilterOptions */.D)({
        matchFrom: "start",
        stringify: function(option) {
            return option;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CitySelectorWrapper, {
        width: width,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextFieldWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationIconWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {
                            color: "secondary"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
                        freeSolo: true,
                        autoComplete: true,
                        autoHighlight: true,
                        onChange: handleAutocompleteSelection,
                        options: cityNames,
                        inputValue: inputValue,
                        filterOptions: filterOptions,
                        renderOption: function(option) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                fontWeight: 500,
                                id: "city-selector-".concat(option),
                                children: option
                            });
                        },
                        renderInput: function(params) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IntlCitySelector_StyledTextField, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params), {
                                placeholder: fromTabletDown ? t("customerLandingPage.citySelectorMobile") : t("customerLandingPage.citySelector"),
                                onChange: function(event) {
                                    return setInputValue(event.target.value);
                                },
                                InputProps: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, params.InputProps), {
                                    disableUnderline: true
                                })
                            }));
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextFieldButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextFieldButton, {
                    size: "lg",
                    onClick: handleFindCaterersSelection,
                    rounded: true,
                    "aria-label": t(buttonLabelKey),
                    children: fromTabletDown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}) : t(buttonLabelKey)
                })
            })
        ]
    });
}
var TextFieldButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(IntlCitySelector_templateObject());
var TextFieldButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(IntlCitySelector_templateObject1(), function(props) {
    return props.theme.spacing(3);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(3);
});
var CitySelectorWrapper = styled_components_browser_esm/* default.div */.ZP.div(IntlCitySelector_templateObject2(), function(props) {
    return props.width;
}, function(props) {
    return props.theme.transitions.create("box-shadow", {
        duration: ".2s"
    });
}, function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.spacing(0, 10);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(0, 4);
});
var TextFieldWrapper = styled_components_browser_esm/* default.div */.ZP.div(IntlCitySelector_templateObject3());
var LocationIconWrapper = styled_components_browser_esm/* default.div */.ZP.div(IntlCitySelector_templateObject4());
var IntlCitySelector_StyledTextField = (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z)(IntlCitySelector_templateObject5(), function(props) {
    return props.theme.spacing(1.5, 2, 1.5, 6);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1.5, 2, 1.5, 5);
});
/* harmony default export */ var components_IntlCitySelector = (IntlCitySelector);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/customer_landing_page/components/Hero.js

function customer_landing_page_components_Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-repeat: no-repeat;\n  background-color: rgba(48, 48, 48, 0.6);\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    customer_landing_page_components_Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function customer_landing_page_components_Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    customer_landing_page_components_Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var FALLBACK_IMAGE = "/artifacts/images/marketing_pages/eating.webp";
function components_Hero_Hero(param) {
    var title = param.title, subtitle = param.subtitle, headerImage = param.headerImage, titleBottom = param.titleBottom;
    var ref, ref1, ref2;
    var backgroundImage = (headerImage === null || headerImage === void 0 ? void 0 : (ref = headerImage.fields) === null || ref === void 0 ? void 0 : ref.file) ? "https:".concat((ref1 = headerImage.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url, "?w=1440") : FALLBACK_IMAGE;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                priority: true,
                src: backgroundImage,
                layout: "fill",
                alt: "",
                objectPosition: "50% 50%",
                objectFit: "cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Hero_HeroContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        mb: {
                            xs: 3,
                            md: 4
                        },
                        mt: {
                            xs: 2,
                            md: 5
                        },
                        color: "#ffffff",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Typography */.ZT, {
                                variant: "h1",
                                mb: 3,
                                children: [
                                    title,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    titleBottom
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                mb: 2,
                                variant: mobile ? "subtitle2" : "subtitle1",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IntlCitySelector, {
                        buttonLabelKey: "customerLandingPage.searchButton",
                        redirectURL: (0,helpers/* buildFunnelUrl */.$e)({
                            router: router
                        })
                    })
                ]
            })
        ]
    });
}
var StyledHero = styled_components_browser_esm/* default.div */.ZP.div(customer_landing_page_components_Hero_templateObject(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(5, 3, 0, 3);
});
var components_Hero_HeroContent = styled_components_browser_esm/* default.div */.ZP.div(customer_landing_page_components_Hero_templateObject1(), function(props) {
    return props.theme.spacing(8, 10, 15, 10);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(1, 2, 4, 2);
});
/* harmony default export */ var customer_landing_page_components_Hero = (components_Hero_Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/caterers/constants.js
var constants = __webpack_require__(32646);
// EXTERNAL MODULE: ./src/caterers/services/webToLeadData.js
var webToLeadData = __webpack_require__(89329);
// EXTERNAL MODULE: ./src/lib/bugsnag.js
var bugsnag = __webpack_require__(45817);
// EXTERNAL MODULE: ./src/lib/mouseflow/index.js
var mouseflow = __webpack_require__(42325);
// EXTERNAL MODULE: ./src/lib/yup.ts
var yup = __webpack_require__(33448);
// EXTERNAL MODULE: ./src/shared/components/FormikFormField.js + 2 modules
var FormikFormField = __webpack_require__(3317);
// EXTERNAL MODULE: ./src/shared/services/webToLeadRequest.js + 1 modules
var webToLeadRequest = __webpack_require__(91902);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/customer_landing_page/components/RequestForm.js





function RequestForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  background-color: ",
        ";\n  padding: ",
        ";\n  margin-left: ",
        "px;\n  width: 100%;\n  border-radius: ",
        "px;\n  color: ",
        ";\n\n  ",
        " {\n    margin-left: 0;\n  }\n"
    ]);
    RequestForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var HIDE_SUCCESS_MESSAGE_MILLIS = 5000;
var FORM_ID = "customer-landing-page-request-form";
function RequestForm() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useState)(false), contactFormSubmitted = ref[0], setContactFormSubmitted = ref[1];
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var hideSuccessMessage = setTimeout(function() {
        setContactFormSubmitted(false);
    }, HIDE_SUCCESS_MESSAGE_MILLIS);
    var handleSubmit = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(values, param) {
            var resetForm, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        resetForm = param.resetForm;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        mouseflow/* Mouseflow.notify.formSubmitAttempt */.s.notify.formSubmitAttempt(FORM_ID);
                        return [
                            4,
                            (0,webToLeadRequest/* webToLeadRequest */.v)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, values), {
                                record_type: constants/* CUSTOMER_LEAD_RECORD_TYPE */.f,
                                comment: "\n            -- COMMENT --\n            Comment: ".concat(values.comment, "\n    ")
                            }), webToLeadData/* webToLeadData */.i)
                        ];
                    case 2:
                        _state.sent();
                        setContactFormSubmitted(true);
                        resetForm({
                            values: ""
                        });
                        hideSuccessMessage();
                        mouseflow/* Mouseflow.notify.formSubmitSuccess */.s.notify.formSubmitSuccess(FORM_ID);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        mouseflow/* Mouseflow.notify.formSubmitFailure */.s.notify.formSubmitFailure(FORM_ID);
                        bugsnag/* default.notify */.Z.notify(new Error("[Error trying to submit a webtolead form] with data: ".concat(JSON.stringify(values))));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values, _) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
            px: 3,
            pb: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    pb: 1,
                    textAlign: {
                        xs: "center",
                        md: "left"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "h3",
                        xs: {
                            lineHeight: 1.8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                            t: t,
                            i18nKey: "customerLandingPage.requestForm.title",
                            components: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                    variant: "inherit",
                                    slab: !mobile,
                                    component: "inherit",
                                    color: mobile ? "inherit" : "secondary"
                                }, "title"), 
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "body2",
                    mb: 3,
                    textAlign: {
                        xs: "center",
                        md: "left"
                    },
                    children: t("customerLandingPage.requestForm.subtitle")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    id: FORM_ID,
                    initialValues: {
                        first_name: "",
                        last_name: "",
                        email: "",
                        caterer_name: "",
                        phone: ""
                    },
                    validationSchema: yup/* default.object */.Z.object({
                        first_name: yup/* default.string */.Z.string().required(t("customerLandingPage.requestForm.isRequired")),
                        last_name: yup/* default.string */.Z.string().required(t("customerLandingPage.requestForm.isRequired")),
                        email: yup/* default.string */.Z.string().required(t("customerLandingPage.requestForm.isRequired")).email(t("customerLandingPage.requestForm.correctFormatEmail")),
                        caterer_name: yup/* default.string */.Z.string().required(t("customerLandingPage.requestForm.isRequired")),
                        phone: yup/* default.string */.Z.string().required(t("customerLandingPage.requestForm.isRequired")).matches(constants/* PHONE_NUMBER_REGEX */.d0, t("customerLandingPage.requestForm.phoneError"))
                    }),
                    onSubmit: handleSubmit,
                    enableReinitialize: true,
                    children: function(formikBag) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                    pb: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                        container: true,
                                        spacing: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    required: true,
                                                    label: t("customerLandingPage.requestForm.firstName"),
                                                    placeholder: t("customerLandingPage.requestForm.firstName"),
                                                    name: "first_name",
                                                    component: FormikFormField/* default */.Z
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    required: true,
                                                    label: t("customerLandingPage.requestForm.lastName"),
                                                    placeholder: t("customerLandingPage.requestForm.lastName"),
                                                    name: "last_name",
                                                    component: FormikFormField/* default */.Z
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    required: true,
                                                    label: t("customerLandingPage.requestForm.email"),
                                                    placeholder: t("customerLandingPage.requestForm.email"),
                                                    name: "email",
                                                    component: FormikFormField/* default */.Z
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    required: true,
                                                    label: t("customerLandingPage.requestForm.company"),
                                                    placeholder: t("customerLandingPage.requestForm.company"),
                                                    name: "caterer_name",
                                                    component: FormikFormField/* default */.Z
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    required: true,
                                                    type: "number",
                                                    label: t("customerLandingPage.requestForm.phone"),
                                                    placeholder: t("customerLandingPage.requestForm.phone"),
                                                    name: "phone",
                                                    component: FormikFormField/* default */.Z
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                    display: "flex",
                                    flexDirection: mobile ? "column" : "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                            textAlign: {
                                                xs: "center",
                                                md: "left"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                                                disabled: !formikBag.dirty,
                                                size: "lg",
                                                variant: "primary",
                                                type: "submit",
                                                role: "button",
                                                "aria-label": "submit",
                                                id: "customer-page-request-submit",
                                                children: t("customerLandingPage.requestForm.submit")
                                            })
                                        }),
                                        contactFormSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                            alignSelf: "center",
                                            pt: {
                                                xs: 3,
                                                md: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RequestForm_StyledBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                        color: "inherit"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                        variant: "caption",
                                                        color: "inherit",
                                                        ml: 1,
                                                        children: t("customerLandingPage.successMessage")
                                                    })
                                                ]
                                            })
                                        }) : null
                                    ]
                                })
                            ]
                        });
                    }
                })
            ]
        })
    });
}
var RequestForm_StyledBox = styled_components_browser_esm/* default.div */.ZP.div(RequestForm_templateObject(), function(props) {
    return props.theme.palette.secondary.light;
}, function(props) {
    return props.theme.spacing(1, 1, 1, 1);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.common.white;
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
/* harmony default export */ var components_RequestForm = (RequestForm);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/customer_landing_page/components/RequestSection.js

function RequestSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    RequestSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RequestSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  border-radius: ",
        "px;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    RequestSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







function RequestSection() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
            pb: {
                xs: 5,
                sm: 10
            },
            pt: {
                sm: 6,
                md: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection_StyledGrid, {
                        item: true,
                        sm: 12,
                        md: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RequestSection_ImageWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "People eating",
                                src: "/artifacts/images/marketing_pages/company-lunch.webp",
                                width: 448,
                                height: 411
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RequestForm, {})
                    })
                ]
            })
        })
    });
}
var RequestSection_StyledGrid = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)(RequestSection_templateObject(), function(props) {
    return props.theme.breakpoints.down("sm");
});
var RequestSection_ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(RequestSection_templateObject1(), function(props) {
    return props.theme.spacing(1.5);
}, function(props) {
    return props.theme.breakpoints.down("sm");
});
/* harmony default export */ var components_RequestSection = (RequestSection);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/customer_landing_page/components/StepsToCatering.js

function StepsToCatering_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  ",
        " {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  ",
        " {\n    flex-direction: column;\n    padding: ",
        ";\n  }\n"
    ]);
    StepsToCatering_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StepsToCatering_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 33%;\n  text-align: center;\n  ",
        " {\n    width: 33%;\n  }\n  ",
        " {\n    width: 100%;\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n  }\n"
    ]);
    StepsToCatering_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function StepsToCatering(param) {
    var cta = param.cta, link = param.link;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        my: {
            xs: 6,
            sm: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mb: {
                    xs: 4,
                    sm: 6
                },
                px: {
                    xs: 5,
                    md: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "h3",
                    textAlign: "center",
                    xs: {
                        lineHeight: 1.5
                    },
                    children: t("customerLandingPage.stepsToCatering.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsToCateringContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsToCateringItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsToCatering_IconWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    src: "/artifacts/images/marketing_pages/customer-city.webp",
                                    width: 116.75,
                                    height: 104
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                px: 2,
                                flex: 1,
                                sm: {
                                    textAlign: "center"
                                },
                                pb: {
                                    xs: 3,
                                    md: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "body1",
                                        fontWeight: 600,
                                        children: t("customerLandingPage.stepsToCatering.cityTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "body1",
                                        px: {
                                            sm: 3,
                                            md: 10
                                        },
                                        children: t("customerLandingPage.stepsToCatering.cityBody")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsToCateringItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsToCatering_IconWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    src: "/artifacts/images/marketing_pages/customer-compare.webp",
                                    width: 116.75,
                                    height: 104
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                px: 2,
                                flex: 1,
                                sm: {
                                    textAlign: "center"
                                },
                                pb: {
                                    xs: 3,
                                    md: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "body1",
                                        fontWeight: 600,
                                        children: t("customerLandingPage.stepsToCatering.compareTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "body1",
                                        px: {
                                            sm: 3,
                                            md: 12
                                        },
                                        children: t("customerLandingPage.stepsToCatering.compareBody")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepsToCateringItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepsToCatering_IconWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "",
                                    src: "/artifacts/images/marketing_pages/customer-enjoy.webp",
                                    width: 116.75,
                                    height: 104
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                px: 2,
                                flex: 1,
                                sm: {
                                    textAlign: "center"
                                },
                                pb: {
                                    xs: 3,
                                    md: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "body1",
                                        fontWeight: 600,
                                        children: t("customerLandingPage.stepsToCatering.enjoyTitle")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: "body1",
                                        px: {
                                            sm: 3,
                                            md: 10
                                        },
                                        children: t("customerLandingPage.stepsToCatering.enjoyBody")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                textAlign: "center",
                mt: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                    size: "lg",
                    rounded: true,
                    id: "steps-to-catering-button",
                    as: "a",
                    href: link,
                    target: "_blank",
                    children: cta
                })
            })
        ]
    });
}
function StepsToCatering_IconWrapper(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        mb: {
            xs: 0,
            md: 0,
            lg: 2
        },
        display: "flex",
        justifyContent: "center",
        children: children
    });
}
var StepsToCateringContent = styled_components_browser_esm/* default.div */.ZP.div(StepsToCatering_templateObject(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 8, 0, 8);
});
var StepsToCateringItem = styled_components_browser_esm/* default.div */.ZP.div(StepsToCatering_templateObject1(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
/* harmony default export */ var components_StepsToCatering = (StepsToCatering);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/customer_landing_page/index.js



















function CustomerLandingPage(param) {
    var page = param.page, ratings = param.ratings;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: page.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: page.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: page.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: page.metaDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_landing_page_components_Hero, {
                title: page.heroTitle,
                titleBottom: page.heroTitleBottom,
                subtitle: page.heroSubtitle,
                headerImage: page.headerImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialProofBar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSectionA, {
                        header: page.section1Header,
                        body: page.section1Body,
                        image: page.section1Image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StepsToCatering, {
                        cta: page.stepsToCateringCta,
                        link: page.stepsToCateringCtaLink
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TrustedCustomers, {
                title: "customerLandingPage.trustedBy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        mt: {
                            xs: 6,
                            sm: 10
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSectionC, {
                            header: page.section2Header,
                            subtitle: page.section2Subtitle,
                            content: page.section2ContentBlock,
                            cta: page.section2Cta,
                            link: page.section2CtaLink
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSectionB, {
                        header: page.section3Header,
                        content: page.section3ContentBlock,
                        cta: page.section3Cta,
                        link: page.section3CtaLink
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials, {
                        header: page.section4Header,
                        content: page.section4ContentBlock
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RequestSection, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterClean/* default */.Z, {
                title: "customerLandingPage.footerTitle",
                cta: "customerLandingPage.footerCta",
                link: "start"
            })
        ]
    });
}
function customer_landing_page_getStaticProps() {
    return marketing_pages_customer_landing_page_getStaticProps.apply(this, arguments);
}
function marketing_pages_customer_landing_page_getStaticProps() {
    marketing_pages_customer_landing_page_getStaticProps = _async_to_generator(function() {
        var ratings;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchRatings()
                    ];
                case 1:
                    ratings = _state.sent();
                    return [
                        2,
                        {
                            props: {
                                robots: "none",
                                ratings: ratings
                            }
                        }
                    ];
            }
        });
    });
    return marketing_pages_customer_landing_page_getStaticProps.apply(this, arguments);
}
/* harmony default export */ var customer_landing_page = (CustomerLandingPage);

// EXTERNAL MODULE: ./src/shared/hooks/useLocalizeCity.js
var useLocalizeCity = __webpack_require__(9988);
// EXTERNAL MODULE: ./src/shared/services/trustedShops/handleRatings.ts
var handleRatings = __webpack_require__(95046);
// EXTERNAL MODULE: ./src/static_pages/components/ImageCardSlider.tsx
var ImageCardSlider = __webpack_require__(73743);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/CertificateSection.tsx + 1 modules
var CertificateSection = __webpack_require__(41534);
// EXTERNAL MODULE: ./src/shared/components/FlexBox.tsx
var FlexBox = __webpack_require__(85249);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/BenefitsSection.js

function BenefitsSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  padding: ",
        ";\n  flex-direction: column;\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n  }\n"
    ]);
    BenefitsSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BenefitsSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-grow: 1;\n  max-width: 300px;\n  width: 100%;\n\n  ",
        " {\n    width: 600px;\n    max-width: none;\n  }\n"
    ]);
    BenefitsSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BenefitsSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  display: grid;\n  grid-column-gap: ",
        "px;\n  grid-row-gap: ",
        "px;\n  grid-template-columns: 1fr 1fr;\n  justify-items: center;\n  align-items: start;\n\n  ",
        " {\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-column-gap: ",
        "px;\n    grid-row-gap: ",
        "px;\n  }\n  ",
        " {\n    grid-column-gap: ",
        "px;\n  }\n"
    ]);
    BenefitsSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BenefitsSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  line-height: 160%;\n\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    BenefitsSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








function BenefitsSection() {
    var t = (0,useTranslation/* useTranslation */.$)("dynamic_landing_page").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        as: "section",
        size: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            position: "relative",
            alignItems: "center",
            py: 4,
            gap: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsSection_ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        height: 887,
                        width: 1076,
                        layout: "responsive",
                        src: "/artifacts/images/marketing_pages/benefits_img.webp"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                    py: {
                        xs: 0,
                        md: 3
                    },
                    gap: 3,
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TypographySectionTitle, {
                            px: 2,
                            textAlign: "center",
                            variant: "h3",
                            fontSize: "24px",
                            children: [
                                t("common:benefits.title.part1"),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                t("common:benefits.title.part2")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsGrid, {})
                    ]
                })
            ]
        })
    });
}
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z)(BenefitsSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4, 0);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(6);
});
var BenefitsSection_ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(BenefitsSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var BenefitsGrid = styled_components_browser_esm/* default.ul */.ZP.ul(BenefitsSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(8);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var TypographySectionTitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(BenefitsSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
/* harmony default export */ var components_BenefitsSection = (BenefitsSection);

// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/index.tsx
var EmbeddedFunnel = __webpack_require__(73733);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/Hero/Ratings.tsx
var Ratings = __webpack_require__(27258);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/Hero/TrustedCustomers.js
var Hero_TrustedCustomers = __webpack_require__(66972);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/Hero/index.tsx

function dynamic_landing_page_components_Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  white-space: pre-line;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    dynamic_landing_page_components_Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dynamic_landing_page_components_Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 119%;\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    font-size: 38px;\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    dynamic_landing_page_components_Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function components_Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  background-color: white;\n\n  ",
        " {\n    display: block;\n    position: absolute;\n    border-radius: 20px;\n    overflow: hidden;\n\n    background-color: white;\n    right: 47px;\n    bottom: 38px;\n    width: fit-content;\n  }\n"
    ]);
    components_Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: radial-gradient(\n    124.78% 92.5% at 93.04% 116.94%,\n    rgba(22, 29, 23, 0.8) 0%,\n    rgba(85, 116, 71, 0.8) 100%\n  );\n  mix-blend-mode: normal;\n  display: flex;\n  flex-direction: column;\n\n  overflow: hidden;\n  text-align: center;\n\n  ",
        " {\n    min-height: 600px;\n  }\n\n  ",
        " {\n    padding: ",
        "px;\n  }\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Hero_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n  height: 100%;\n  align-self: center;\n  align-items: center;\n  flex-direction: column;\n  padding: ",
        ";\n  padding-left: 2rem;\n  padding-right: 2rem;\n\n  ",
        " {\n    padding: ",
        ";\n  }\n"
    ]);
    Hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Hero_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        "px;\n  flex-grow: 0;\n  height: 100%;\n"
    ]);
    Hero_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var Hero_FALLBACK_IMAGE = "/artifacts/images/marketing_pages/catering.webp";
function dynamic_landing_page_components_Hero_Hero(param) {
    var title = param.title, headerImage = param.headerImage, ratings = param.ratings;
    var ref, ref1, ref2;
    var backgroundImage = (headerImage === null || headerImage === void 0 ? void 0 : (ref = headerImage.fields) === null || ref === void 0 ? void 0 : ref.file) ? "https:".concat((ref1 = headerImage.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url, "?w=1440") : Hero_FALLBACK_IMAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                src: backgroundImage,
                layout: "fill",
                priority: true,
                objectPosition: "50% 74%",
                objectFit: "cover",
                quality: 70
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroMainContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    width: "100%",
                    color: "#ffffff",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyTitle, {
                        variant: "h1",
                        component: "h1",
                        children: title
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mb: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbeddedFunnel/* default */.Z, {
                    renderTitle: function(title) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Subtitle, {
                            component: "h2",
                            variant: "subtitle2",
                            children: [
                                title,
                                "\xa0"
                            ]
                        });
                    },
                    slides: {
                        customerTier: {
                            whiteWrapper: true
                        }
                    },
                    ratings: ratings,
                    highlightColor: "primary",
                    onBackground: "dark"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroFooter, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_TrustedCustomers/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings/* default */.Z, {
                    rating: (0,handleRatings/* getRating */.h1)(ratings)
                })
            })
        ]
    });
}
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(dynamic_landing_page_components_Hero_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var TypographyTitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(dynamic_landing_page_components_Hero_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var RatingsWrapper = styled_components_browser_esm/* default.div */.ZP.div(components_Hero_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var Hero_StyledHero = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.spacing(0);
});
var HeroMainContent = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject4(), function(props) {
    return props.theme.spacing(4, 3, 0, 3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(props) {
    return props.theme.spacing(4, 2, 0, 2);
});
var HeroFooter = styled_components_browser_esm/* default.div */.ZP.div(Hero_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
/* harmony default export */ var dynamic_landing_page_components_Hero = (dynamic_landing_page_components_Hero_Hero);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/HowItWorksCTA.js




function HowItWorksCTA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 42px;\n  display: inline-grid;\n  place-content: center;\n  white-space: normal;\n"
    ]);
    HowItWorksCTA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HowItWorksCTA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding: 0;\n  flex-direction: column;\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n  max-width: 350px;\n  margin: auto;\n  gap: ",
        "px;\n\n  ",
        " {\n    gap: ",
        "px;\n    flex-direction: row;\n    max-width: none;\n  }\n"
    ]);
    HowItWorksCTA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HowItWorksCTA_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 25%;\n  text-align: center;\n\n  ",
        " {\n    width: 33%;\n  }\n\n  ",
        " {\n    width: 100%;\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n  }\n"
    ]);
    HowItWorksCTA_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HowItWorksCTA_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 600;\n  white-space: pre-line;\n  margin-top: ",
        "px;\n"
    ]);
    HowItWorksCTA_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HowItWorksCTA_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n"
    ]);
    HowItWorksCTA_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










function HowItWorksCTA_HowItWorksCTA(_param) {
    var cta = _param.cta, cateringCategories = _param.cateringCategories, cityFromSlug = _param.cityFromSlug, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "cta",
        "cateringCategories",
        "cityFromSlug"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("dynamic_landing_page").t;
    var ref = (0,useCities/* default */.Z)(), cities = ref.cities, cityKeys = ref.cityKeys;
    var cityKey = cityKeys.find(function(cityKey) {
        return cities[cityKey] === cityFromSlug;
    });
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        as: "section",
        pt: 8,
        pb: {
            xs: 4,
            md: 6
        },
        my: {
            xs: 2,
            md: 4
        },
        bgcolor: "#F9F9F4"
    }, restProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            size: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    maxWidth: "730px",
                    px: 2,
                    mb: 3,
                    mx: "auto",
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "h3",
                        lineHeight: "150%",
                        fontSize: "24px",
                        component: "h3",
                        children: t("howItWorks.title")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HowItWorksContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HowItWorksItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksCTA_IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "",
                                        src: "/artifacts/images/marketing_pages/howItWorks_1.svg",
                                        width: 120,
                                        height: 120
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                    flex: 1,
                                    sm: {
                                        textAlign: "center"
                                    },
                                    pb: {
                                        xs: 3,
                                        md: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyItemTitle, {
                                            variant: "subtitle1",
                                            component: "p",
                                            pb: 1,
                                            children: t("howItWorks.part1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyItemSubtitle, {
                                            variant: "body1",
                                            children: t("howItWorks.subtitle1")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HowItWorksItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksCTA_IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "",
                                        src: "/artifacts/images/marketing_pages/howItWorks_2.svg",
                                        width: 120,
                                        height: 120
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                    flex: 1,
                                    sm: {
                                        textAlign: "center"
                                    },
                                    pb: {
                                        xs: 3,
                                        md: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyItemTitle, {
                                            variant: "subtitle1",
                                            component: "p",
                                            pb: 1,
                                            children: t("howItWorks.part2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyItemSubtitle, {
                                            variant: "body1",
                                            children: t("howItWorks.subtitle2")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HowItWorksItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksCTA_IconWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        alt: "",
                                        src: "/artifacts/images/marketing_pages/howItWorks_3.svg",
                                        width: 120,
                                        height: 120
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                    flex: 1,
                                    sm: {
                                        textAlign: "center"
                                    },
                                    pb: {
                                        xs: 3,
                                        md: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyItemTitle, {
                                            variant: "subtitle1",
                                            component: "p",
                                            pb: 1,
                                            children: t("howItWorks.part3")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyItemSubtitle, {
                                            variant: "body1",
                                            children: t("howItWorks.subtitle3")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    pt: 2,
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAButton, {
                        variant: "primary",
                        size: "lg",
                        rounded: true,
                        id: "how-it-works-button",
                        as: "a",
                        href: (0,helpers/* buildFunnelUrl */.$e)({
                            city: cityKey,
                            cateringCategories: cateringCategories,
                            router: router
                        }),
                        targe: "_blank",
                        children: cta
                    })
                })
            ]
        })
    }));
}
function HowItWorksCTA_IconWrapper(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        mb: {
            xs: 0,
            md: 0,
            lg: 2
        },
        display: "flex",
        justifyContent: "center",
        children: children
    });
}
var CTAButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(HowItWorksCTA_templateObject());
var HowItWorksContent = styled_components_browser_esm/* default.ol */.ZP.ol(HowItWorksCTA_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(3, 0);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(props) {
    return props.theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(6);
});
var HowItWorksItem = styled_components_browser_esm/* default.li */.ZP.li(HowItWorksCTA_templateObject2(), function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var TypographyItemTitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(HowItWorksCTA_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var TypographyItemSubtitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(HowItWorksCTA_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.grey.secondary;
});
/* harmony default export */ var components_HowItWorksCTA = (HowItWorksCTA_HowItWorksCTA);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(63786);
;// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/StarRate.js


/* harmony default export */ var StarRate = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  transform: "scale(1.33, 1.33)",
  d: "M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z"
}), 'StarRate'));
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/RatingsSecondary.tsx

function RatingsSecondary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: ",
        "px;\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n  text-decoration: none;\n  color: inherit;\n"
    ]);
    RatingsSecondary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RatingsSecondary_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n  margin-top: -5px;\n"
    ]);
    RatingsSecondary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var RatingsSecondary = function(param) {
    var rating = param.rating, ratingCount = param.ratingCount;
    var isTablet = (0,useBreakpoints/* useBreakpointUp */._)("md");
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingsSecondary_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                children: Array(Math.ceil(rating)).fill(1).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRate, {
                        htmlColor: "#F6D31B"
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                fontWeight: 600,
                fontSize: 14,
                children: (0,handleRatings/* formatRating */.A6)(rating)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                fontSize: 14,
                children: t("trustedShops.ratingText")
            }),
            isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                className: "rating-count",
                fontSize: 14,
                children: t("trustedShops.ratingCount", {
                    amount: (0,handleRatings/* formatRatingCount */.mj)(ratingCount)
                })
            })
        ]
    });
};
var RatingsSecondary_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(RatingsSecondary_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Stars = styled_components_browser_esm/* default.div */.ZP.div(RatingsSecondary_templateObject1(), function(param) {
    var spacing = param.theme.spacing;
    return spacing(0);
});
/* harmony default export */ var components_RatingsSecondary = (RatingsSecondary);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var esm_ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./src/shared/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(41210);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/ReadMoreArea.js

function ReadMoreArea_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  max-height: ",
        "px;\n"
    ]);
    ReadMoreArea_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReadMoreArea_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: rotate(",
        "deg);\n"
    ]);
    ReadMoreArea_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReadMoreArea_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  line-height: 172.5%;\n  border: none;\n  background-color: inherit;\n\n  text-align: center;\n  text-decoration-line: underline;\n\n  :hover {\n    color: rgba(0, 0, 0, 0.75);\n  }\n\n  cursor: pointer;\n"
    ]);
    ReadMoreArea_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ReadMoreArea_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 90px;\n  width: 100%;\n  left: 0;\n  right: 0;\n  position: absolute;\n  bottom: 0;\n  z-index: 10;\n  opacity: ",
        ";\n  transition: all, 0.3s ease;\n  background: linear-gradient(\n    0deg,\n    #fff 0%,\n    #fff 10%,\n    rgba(255, 255, 255, 0) 100%\n  );\n\n  transform: ",
        ";\n"
    ]);
    ReadMoreArea_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var ReadMoreArea = function(param) {
    var children = param.children, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 350 : _maxHeight;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,react.useState)(), contentHeight = ref1[0], setContentHeight = ref1[1];
    var contentWrapperRef = (0,react.useRef)(null);
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    var windowSize = (0,useWindowSize/* useWindowSize */.i)();
    var maxNonExpandableHeight = maxHeight - 50;
    var isExpandable = contentHeight > maxHeight;
    (0,react.useEffect)(function() {
        var ref;
        setContentHeight(contentWrapperRef === null || contentWrapperRef === void 0 ? void 0 : (ref = contentWrapperRef.current) === null || ref === void 0 ? void 0 : ref.scrollHeight);
    }, [
        isExpanded,
        windowSize
    ]);
    (0,react.useLayoutEffect)(function() {
        setExpanded(false);
    }, [
        isExpandable
    ]);
    var wrapperHeight = isExpanded ? contentHeight : Math.min(contentHeight, maxNonExpandableHeight);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReadMoreArea_Wrapper, {
                ref: contentWrapperRef,
                isExpanded: isExpanded,
                maxHeight: wrapperHeight,
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteFade, {
                        hidden: isExpanded || !isExpandable
                    })
                ]
            }),
            isExpandable && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* default */.Z, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReadMoreButton, {
                    onClick: function() {
                        return setExpanded(!isExpanded);
                    },
                    children: [
                        isExpanded ? t("action.collapse") : t("action.readMore"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            fontSize: 18,
                            ml: 1,
                            mt: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {
                                fontSize: "inherit",
                                direction: isExpanded ? "up" : "down"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var ReadMoreArea_Wrapper = styled_components_browser_esm/* default.div */.ZP.div(ReadMoreArea_templateObject(), function(param) {
    var maxHeight = param.maxHeight, isExpanded = param.isExpanded;
    return isExpanded ? maxHeight : maxHeight + 10;
});
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(esm_ArrowForwardIos/* default */.Z)(ReadMoreArea_templateObject1(), function(param) {
    var direction = param.direction;
    return direction === "down" ? 90 : -90;
});
var ReadMoreButton = styled_components_browser_esm/* default.button */.ZP.button(ReadMoreArea_templateObject2());
var WhiteFade = styled_components_browser_esm/* default.div */.ZP.div(ReadMoreArea_templateObject3(), function(param) {
    var hidden = param.hidden;
    return hidden ? 0 : 1;
}, function(param) {
    var position = param.position;
    return position === "left" ? "rotate(-180deg)" : "none";
});
/* harmony default export */ var components_ReadMoreArea = (ReadMoreArea);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/RenderMarkdown.js

function RenderMarkdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    RenderMarkdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function RenderMarkdown(param) {
    var content = param.content;
    var ref, ref1;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderMarkdown_StyledBox, {
        children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(content, (0,contentful/* embeddedAssetOptions */.k)((ref = content.links) === null || ref === void 0 ? void 0 : (ref1 = ref.assets) === null || ref1 === void 0 ? void 0 : ref1.block))
    });
}
var RenderMarkdown_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(RenderMarkdown_templateObject(), function(props) {
    return props.theme.palette.primary.main;
});
/* harmony default export */ var components_RenderMarkdown = (RenderMarkdown);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./src/hub/components/Sticky.js
var Sticky = __webpack_require__(95717);
// EXTERNAL MODULE: ./src/lib/cssVariables.js
var cssVariables = __webpack_require__(75150);
// EXTERNAL MODULE: ./src/shared/hooks/useDebounce.ts
var useDebounce = __webpack_require__(96917);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/components/StickySectionsNavigation.js




function StickySectionsNavigation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(-2px - var(",
        "));\n  left: 0;\n  right: 0;\n  pointer-events: none;\n  margin-top: -1px;\n  height: 1px;\n"
    ]);
    StickySectionsNavigation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StickySectionsNavigation_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  ",
        " {\n    background-color: #fff;\n  }\n"
    ]);
    StickySectionsNavigation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StickySectionsNavigation_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  flex-shrink: 0;\n  margin: 0;\n"
    ]);
    StickySectionsNavigation_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StickySectionsNavigation_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n  list-style: none;\n  display: flex;\n  margin: 0;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  justify-content: center;\n\n  ",
        " {\n    justify-content: flex-start;\n  }\n"
    ]);
    StickySectionsNavigation_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function StickySectionsNavigation_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-right: 1rem;\n  color: ",
        ";\n  text-decoration: none;\n  background: ",
        ";\n  border-radius: 500px;\n  padding: ",
        ";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  height: 38px;\n  display: grid;\n  place-content: center;\n\n  &:hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    StickySectionsNavigation_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function StickySectionsNavigation_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin-right: 1rem;\n  color: ",
        ";\n  text-decoration: none;\n  background: ",
        ";\n  border-radius: 500px;\n  padding: ",
        ";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  height: 38px;\n  display: grid;\n  place-content: center;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    StickySectionsNavigation_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function StickySectionsNavigation_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scroll-margin-top: ",
        "px;\n"
    ]);
    StickySectionsNavigation_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}














var StickySectionsNavigation_TrackedSection = function(_param) {
    var id = _param.id, label = _param.label, children = _param.children, props = _object_without_properties(_param, [
        "id",
        "label",
        "children"
    ]);
    var ref = useCurrentSection(), addSection = ref.addSection, topOffset = ref.topOffset;
    useEffect(function() {
        addSection({
            id: id,
            label: label
        });
    }, []);
    return /*#__PURE__*/ _jsx(StickySectionsNavigation_TrackedSectionBox, _object_spread_props(_object_spread({
        scrollTopOffset: topOffset,
        id: id,
        as: "section"
    }, props), {
        children: children
    }));
};
function StickySectionsNavigation(param) {
    var title = param.title;
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var ref = PageSections_useCurrentSection(), sections = ref.sections, activeSection = ref.activeSection;
    var ref1 = (0,react_intersection_observer_m/* useInView */.YD)({
        threshold: 1
    }), ref2 = ref1.ref, inView = ref1.inView;
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    var isSticky = !inView;
    var router = (0,next_router.useRouter)();
    var sectionElementsRef = (0,react.useRef)({});
    var parentRef = (0,react.useRef)(null);
    var debouncedActiveSection = (0,useDebounce/* default */.Z)(activeSection, 300);
    (0,react.useEffect)(function() {
        var horizontallyCenterTheActiveSectionLabel = function horizontallyCenterTheActiveSectionLabel() {
            var activeSectionElement = sectionElementsRef.current[debouncedActiveSection.id];
            if (activeSectionElement && parentRef.current) {
                var parentElement = parentRef.current;
                var childElement = activeSectionElement;
                var parentWidth = parentElement.offsetWidth;
                var childWidth = childElement.offsetWidth;
                var childOffsetLeft = childElement.offsetLeft;
                var scrollLeft = childOffsetLeft - (parentWidth - childWidth) / 2;
                parentElement.scrollLeft = scrollLeft;
            }
        };
        if (!debouncedActiveSection) {
            return;
        }
        horizontallyCenterTheActiveSectionLabel();
    }, [
        debouncedActiveSection
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky/* Sticky */.L, {
                hideOnScroll: isMobile,
                as: "nav",
                top: "var(".concat(cssVariables/* cssVars.topBarHeight.name */.D.topBarHeight.name, ")"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StickinessTracker, {
                            ref: ref2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, {
                            isSticky: isSticky,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionList, {
                                ref: parentRef,
                                children: [
                                    sections.map(function(param) {
                                        var id = param.id, label = param.label;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink, {
                                                ref: function(element) {
                                                    return sectionElementsRef.current[id] = element;
                                                },
                                                as: "a",
                                                href: "#".concat(id),
                                                active: (activeSection === null || activeSection === void 0 ? void 0 : activeSection.id) === id,
                                                children: label
                                            })
                                        }, id);
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            passHref: true,
                                            href: (0,helpers/* buildFunnelUrl */.$e)({
                                                router: router
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaLink, {
                                                as: "a",
                                                active: true,
                                                children: t("labels.findCaterersNow")
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var StickinessTracker = styled_components_browser_esm/* default.div */.ZP.div(StickySectionsNavigation_templateObject(), cssVariables/* cssVars.topBarHeight.name */.D.topBarHeight.name);
var BackgroundColor = styled_components_browser_esm/* default.div */.ZP.div(StickySectionsNavigation_templateObject1(), function(param) {
    var isSticky = param.isSticky;
    return isSticky ? "#f8f8f8" : "#fff";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ListItem = styled_components_browser_esm/* default.li */.ZP.li(StickySectionsNavigation_templateObject2());
var SectionList = styled_components_browser_esm/* default.ul */.ZP.ul(StickySectionsNavigation_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("md");
});
var SectionLink = styled_components_browser_esm/* default.a */.ZP.a(StickySectionsNavigation_templateObject4(), function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.palette.common.white : theme.palette.text.secondary;
}, function(param) {
    var active = param.active, theme = param.theme;
    return active ? theme.palette.secondary.light : theme.palette.text.disabled;
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2.5);
}, function(param) {
    var active = param.active;
    return !active && "hsla(69, 53%, 70%, .19)";
}, function(param) {
    var theme = param.theme;
    return theme.palette.secondary.dark;
});
var CtaLink = styled_components_browser_esm/* default.a */.ZP.a(StickySectionsNavigation_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.palette.common.white;
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary.main;
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1.5, 2.5);
}, function(param) {
    var theme = param.theme;
    return theme.palette.primary.light;
});
var StickySectionsNavigation_TrackedSectionBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(StickySectionsNavigation_templateObject6(), function(param) {
    var scrollTopOffset = param.scrollTopOffset;
    return scrollTopOffset;
});
/* harmony default export */ var components_StickySectionsNavigation = (StickySectionsNavigation);

// EXTERNAL MODULE: ./src/system/components/Button/DarkButton.js
var DarkButton = __webpack_require__(93925);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/system/components/Typography.js




function Typography_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ", serif;\n  font-weight: ",
        ";\n  font-style: italic;\n"
    ]);
    Typography_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var SlabTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z)(Typography_templateObject(), function(props) {
    return props.theme.typography.fontFamilySlab;
}, function(props) {
    return props.theme.typography.fontWeightSlab;
});
function Typography_Typography(_param) {
    var children = _param.children, _slab = _param.slab, slab = _slab === void 0 ? false : _slab, restProps = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "slab"
    ]);
    var Component = slab ? SlabTypography : Typography/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
}
Typography_Typography.propTypes = {
    slab: (prop_types_default()).bool,
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node, 
    ]).isRequired
};
/* harmony default export */ var components_Typography = (Typography_Typography);

;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/dynamic_landing_page/index.tsx




function dynamic_landing_page_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    dynamic_landing_page_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function dynamic_landing_page_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    dynamic_landing_page_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function dynamic_landing_page_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    dynamic_landing_page_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


































function dynamic_landing_page_DynamicLandingPage(param) {
    var page = param.page, ratings = param.ratings;
    var mapCaterersToCards = function mapCaterersToCards(items) {
        return items.reduce(function(acc, caterer) {
            if (caterer.profile_image) {
                acc.push({
                    key: caterer.slogan_en || "",
                    href: (0,urls/* marketplaceURL */.j5)("/catering/".concat((0,cities/* findCitySlug */.r$)(page.city), "/").concat(caterer.slug)),
                    cta: (0,helpers/* capitalizeFirstLetter */.fm)(locale === "de" ? caterer.slogan_de : caterer.slogan_en),
                    ctaHighlight: t("common:preposition.from") + " " + caterer.company_name,
                    imageSrc: caterer.profile_image,
                    pillText: localizedCity
                });
            }
            return acc;
        }, []);
    };
    var mapSearchModelsToCards = function mapSearchModelsToCards(items) {
        return items.reduce(function(acc, param) {
            var fields = param.fields, sys = param.sys;
            var cta = fields.searchCta;
            var imageSrc = (0,contentful/* getContentfulImageUrl */.l)(fields.cardImage);
            if (cta && imageSrc) {
                acc.push({
                    key: sys.id,
                    href: (0,helpers/* buildFunnelUrl */.$e)({
                        city: fields.searchCity,
                        cateringCategories: parseContentfulCateringCategories(fields.searchCateringCategory) || parsedCateringCategories,
                        router: router
                    }),
                    cta: cta,
                    imageSrc: imageSrc
                });
            }
            return acc;
        }, []);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,useTranslation/* useTranslation */.$)("dynamic_landing_page").t;
    var router = (0,next_router.useRouter)();
    var locale = (0,next_router.useRouter)().locale;
    var localizedCity = (0,useLocalizeCity/* getLocalizedCity */.yC)(page.city, t);
    var parsedCateringCategories = parseContentfulCateringCategories(page.keywords);
    var city = usePreselectedCity({
        cityFromPath: page.city
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
        ratings: ratings,
        renderNavbarCta: function() {
            return null;
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* QualificationProvider */.S, {
            storage: null,
            initialized: {
                nonSkippableQuestions: [
                    "catering_categories"
                ],
                answers: {
                    city: city,
                    catering_categories: parsedCateringCategories
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: page.metaTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: page.metaDescription
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: page.metaTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: page.metaDescription
                        }),
                        page.faQsEnabled && (page === null || page === void 0 ? void 0 : (ref = page.faQs) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify((0,helpers/* buildFaqMarkup */.bB)(page.faQs))
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageSections.Provider, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamic_landing_page_components_Hero, {
                            ratings: ratings,
                            title: page.heroTitle,
                            headerImage: page.headerImage
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StickySectionsNavigation, {
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                pt: {
                                    xs: 4,
                                    md: 8,
                                    lg: 10
                                },
                                pb: {
                                    xs: 2,
                                    md: 1
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationSubtitleTypography, {
                                    align: "center",
                                    children: t("topNavigationTitle")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            mt: {
                                xs: 0,
                                md: 3
                            },
                            mb: {
                                xs: 0,
                                md: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CertificateSection/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSections.TrackedSection, {
                            id: "benefits",
                            label: t("section.benefits"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BenefitsSection, {})
                        }),
                        ((ref1 = page.section1FilteredMPCard) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageSections.TrackedSection, {
                            id: "section-1",
                            label: t("section.section1"),
                            mt: 2,
                            pb: 6,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                                    children: page.section1Header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCardSlider/* default */.Z, {
                                    items: mapSearchModelsToCards(page.section1FilteredMPCard)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                    pt: 6,
                                    pb: 4,
                                    textAlign: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkCTAButton, {
                                        href: (0,helpers/* buildFunnelUrl */.$e)({
                                            city: page.city,
                                            cateringCategories: parsedCateringCategories,
                                            router: router
                                        }),
                                        children: page.section1Cta ? page.section1Cta : t("howItWorks.CTA")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    size: "xsm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreArea, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RenderMarkdown, {
                                            content: page.section1Body
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HowItWorksCTA, {
                            cta: page.buttonCta,
                            cateringCategories: page.keywords,
                            cityFromSlug: page.city
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageSections.TrackedSection, {
                            id: "top-caterers",
                            isTracked: !!((ref2 = page.bestRatedCaterers) === null || ref2 === void 0 ? void 0 : ref2.length),
                            label: t("section.topRatedCaterers"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterers/* default */.Z, {
                                    cta: page.section2Cta,
                                    topCaterers: page.bestRatedCaterers,
                                    title: page.section2Header,
                                    city: page.city,
                                    cateringCategories: page.keywords
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    size: "xsm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreArea, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RenderMarkdown, {
                                            content: page.section2Body
                                        })
                                    })
                                })
                            ]
                        }),
                        ((ref3 = page.mostBookedCaterers) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageSections.TrackedSection, {
                            id: "most-booked",
                            isTracked: !!((ref4 = page.mostBookedCaterers) === null || ref4 === void 0 ? void 0 : ref4.length),
                            label: t("section.mostPopularCaterers"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                                    children: [
                                        " ",
                                        page.section3Cta || "Top Caterers"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCardSlider/* default */.Z, {
                                    items: mapCaterersToCards(page.mostBookedCaterers)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    size: "md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        pt: 6,
                                        pb: 4,
                                        textAlign: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkCTAButton, {
                                            href: (0,helpers/* buildFunnelUrl */.$e)({
                                                city: page === null || page === void 0 ? void 0 : page.city,
                                                cateringCategories: parsedCateringCategories,
                                                router: router
                                            }),
                                            children: page.section3Cta ? page.section3Cta : t("catererCards.cta")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    size: "xsm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreArea, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RenderMarkdown, {
                                            content: page.section3Body
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        ((ref5 = page.section4FilteredMpCard) === null || ref5 === void 0 ? void 0 : ref5.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_PageSections.TrackedSection, {
                            id: "section-4",
                            label: t("section.section4"),
                            pb: {
                                xs: 4,
                                md: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
                                    children: page.section4Header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageCardSlider/* default */.Z, {
                                    items: mapSearchModelsToCards(page.section4FilteredMpCard)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    size: "md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        pt: 6,
                                        pb: 4,
                                        textAlign: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkCTAButton, {
                                            href: (0,helpers/* buildFunnelUrl */.$e)({
                                                city: page.city,
                                                cateringCategories: parsedCateringCategories,
                                                router: router
                                            }),
                                            children: page.section4Cta ? page.section4Cta : t("howItWorks.CTA")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    size: "xsm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ReadMoreArea, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RenderMarkdown, {
                                            content: page.section4Body
                                        })
                                    })
                                })
                            ]
                        }) : null,
                        page.faQsEnabled && ((ref6 = page.faQs) === null || ref6 === void 0 ? void 0 : ref6.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PageSections.TrackedSection, {
                            id: "faq",
                            label: "FAQ",
                            pb: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Faqs, {
                                faqs: page.faQs,
                                faqHeadline: page.faqSectionHeadline
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTAWithBenefits/* default */.Z, {
                    cityFromSlug: page.city,
                    containerSize: "sm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks["default"], {
                    pb: 2,
                    pt: 4
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingsSecondary, {
                    rating: (0,handleRatings/* getRating */.h1)(ratings),
                    ratingCount: (0,handleRatings/* getRatingCount */.cz)(ratings)
                })
            ]
        })
    });
}
var NavigationSubtitleTypography = (0,styled_components_browser_esm/* default */.ZP)(components_Typography)(dynamic_landing_page_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var DarkCTAButton = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(DarkButton/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        size: "lg",
        rounded: true,
        as: "a",
        target: "_blank"
    }, props), {
        children: children
    }));
};
var SectionTitleTypography = (0,styled_components_browser_esm/* default */.ZP)(components_Typography)(dynamic_landing_page_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var SectionTitle = (0,styled_components_browser_esm/* default */.ZP)(function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        size: "md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
            py: 6,
            textAlign: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitleTypography, {
                variant: "h3",
                component: "h2",
                gutterBottom: true,
                children: children
            })
        })
    });
})(dynamic_landing_page_templateObject2());
/* harmony default export */ var dynamic_landing_page = (dynamic_landing_page_DynamicLandingPage);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/SEAPage/index.tsx + 2 modules
var SEAPage = __webpack_require__(41402);
;// CONCATENATED MODULE: ./src/pages/[slug].js











var pageTypeComponentMapping = {
    SEARCH_LANDING_PAGE: components_SearchLandingPage,
    SEA_PAGE: SEAPage/* default */.Z,
    COUNTRY_LANDING_PAGE: country_landing_page,
    DYNAMIC_LANDING_PAGE: dynamic_landing_page,
    CUSTOMER_LANDING_PAGE: customer_landing_page,
    DYNAMIC_PAGE: DynamicLandingPage
};
function MarketingPageFactory(_param) {
    var page = _param.page, type = _param.type, restprops = (0,src_object_without_properties/* default */.Z)(_param, [
        "page",
        "type"
    ]);
    (0,cities/* persistCityInLocalStorage */.el)((0,cities/* findCitySlug */.r$)(page.cityFromSlug));
    var Component = pageTypeComponentMapping[type];
    (0,react.useEffect)(function() {
        document.body.dataset.pageType = type !== null && type !== void 0 ? type : "";
        return function() {
            document.body.dataset.pageType = "";
        };
    }, [
        type
    ]);
    if (!Component) {
        throw new Error("[MarketingPageFactory]: Page type not found for type: ".concat(type));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,src_object_spread/* default */.Z)({
        page: page
    }, restprops));
}
var __N_SSG = true;
/* harmony default export */ var _slug_ = (MarketingPageFactory);


/***/ }),

/***/ 31555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50743);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27959);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61201);
/* harmony import */ var _material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64566);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  min-height: auto;\n  &.Mui-expanded {\n    min-height: auto;\n    color: #4e7a0a;\n  }\n\n  .MuiAccordionSummary-content {\n    margin: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: ",
        "px;\n  margin-bottom: ",
        "px;\n\n  background-color: #f0f0f0;\n  box-shadow: none;\n\n  &.Mui-expanded {\n    background-color: #f8f8f8;\n  }\n\n  :before {\n    display: none;\n  }\n\n  &.MuiExpansionPanel-root {\n    border: none;\n    border-radius: 8px 8px 0 0;\n  }\n\n  &.MuiExpansionPanel-root:before {\n    display: none;\n    height: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  color: ",
        ";\n  padding: ",
        ";\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  & > p {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function Accordion(param) {
    var summary = param.summary, details = param.details;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledAccordion, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAccordionSummary, {
                expandIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons_ExpandMore__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                children: typeof summary === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                    py: 1,
                    variant: "subtitle1",
                    fontWeight: 600,
                    fontSize: 16,
                    component: "h3",
                    children: summary
                }) : summary
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAccordionDetails, {
                children: typeof details === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                    fontSize: 16,
                    pb: 2,
                    variant: "subtitle2",
                    children: details
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: details
                })
            })
        ]
    });
}
var StyledAccordionSummary = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(0, 1.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 3);
});
var StyledAccordion = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_templateObject1(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1.5);
});
var StyledAccordionDetails = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_templateObject2(), function(props) {
    return props.theme.palette.grey[700];
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1, 3, 0, 1.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 8, 0, 3);
});
/* harmony default export */ __webpack_exports__["default"] = (Accordion);


/***/ }),

/***/ 73733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85444);
/* harmony import */ var qualification_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85643);
/* harmony import */ var qualification_context_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91538);
/* harmony import */ var shared_components_EmbeddedFunnel_EmbeddedQuestion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13792);
/* harmony import */ var shared_components_EmbeddedFunnel_EmbeddedQuestionLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11156);
/* harmony import */ var shared_helpers_urls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6880);
/* harmony import */ var shared_components_EmbeddedFunnel_LoadingIndicator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61654);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --embedded-text-color: ",
        ";\n  width: 100%;\n  position: relative;\n\n  :focus,\n  :focus-visible {\n    outline: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var EmbeddedRequestPage = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3234), __webpack_require__.e(8184), __webpack_require__.e(1507), __webpack_require__.e(5627), __webpack_require__.e(8832), __webpack_require__.e(2719), __webpack_require__.e(3644)]).then(__webpack_require__.bind(__webpack_require__, 43644));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43644)
            ];
        }
    }
});

// eslint-disable-next-line react/display-name
var EmbeddedFunnel = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(param, ref) {
    var onBackground = param.onBackground, highlightColor = param.highlightColor, ratings = param.ratings, slides = param.slides, renderTitle = param.renderTitle, titleTranslationKeys = param.titleTranslationKeys, _LayoutComponent = param.LayoutComponent, LayoutComponent = _LayoutComponent === void 0 ? shared_components_EmbeddedFunnel_EmbeddedQuestionLayout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z : _LayoutComponent;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5, _$ref6;
    var scrollHelperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var onQuestionChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (scrollHelperRef && (scrollHelperRef === null || scrollHelperRef === void 0 ? void 0 : scrollHelperRef.current)) {
            scrollHelperRef.current.scrollIntoView({
                inline: "nearest",
                block: "nearest",
                behavior: "smooth"
            });
        }
    }, []);
    var _$ref7 = (0,qualification_context__WEBPACK_IMPORTED_MODULE_5__/* .useQualification */ ._8)({
        onQuestionChange: onQuestionChange
    }), state = _$ref7.state, actions = _$ref7.actions, canContinue = _$ref7.canContinue;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (scrollHelperRef && (scrollHelperRef === null || scrollHelperRef === void 0 ? void 0 : scrollHelperRef.current)) {
            scrollHelperRef.current.scrollIntoView({
                inline: "nearest",
                block: "nearest",
                behavior: "smooth"
            });
        }
    }, [
        state.status
    ]);
    var toNextStep = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        actions.nextStep();
    }, [
        actions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (state.status === qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.qualifiedForMarketplace */ .w.qualifiedForMarketplace) {
            (0,shared_helpers_urls__WEBPACK_IMPORTED_MODULE_9__/* .redirectToMarketplace */ .c9)(state.marketplaceUrl);
        }
    }, [
        state
    ]);
    if (state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.answered */ .w.answered && state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.answering */ .w.answering && state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.qualifiedForRequest */ .w.qualifiedForRequest) {
        return null;
    }
    var stepId = state.status === "answering" && ((_$ref = state.qualification.step) === null || _$ref === void 0 ? void 0 : _$ref.id) || "";
    var onKeyPress = function(event) {
        if (event.key === "Enter" && canContinue) {
            event.preventDefault();
            toNextStep();
        }
    };
    if (state.status === qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.qualifiedForRequest */ .w.qualifiedForRequest) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmbeddedRequestPage, {
            ratings: ratings
        });
    }
    var textColor = onBackground === "light" ? "dark" : "light";
    if (stepId.includes("customer-") && (slides === null || slides === void 0 ? void 0 : (_$ref1 = slides.customerTier) === null || _$ref1 === void 0 ? void 0 : _$ref1.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "city" && (slides === null || slides === void 0 ? void 0 : (_$ref2 = slides.city) === null || _$ref2 === void 0 ? void 0 : _$ref2.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "catering_categories" && (slides === null || slides === void 0 ? void 0 : (_$ref3 = slides.category) === null || _$ref3 === void 0 ? void 0 : _$ref3.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "people_count_and_budget" && (slides === null || slides === void 0 ? void 0 : (_$ref4 = slides.budgetAndPeople) === null || _$ref4 === void 0 ? void 0 : _$ref4.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "dietary_restrictions" && (slides === null || slides === void 0 ? void 0 : (_$ref5 = slides.dietaryRestriction) === null || _$ref5 === void 0 ? void 0 : _$ref5.whiteWrapper)) {
        textColor = "dark";
    }
    if (stepId === "event_date" && (slides === null || slides === void 0 ? void 0 : (_$ref6 = slides.dateAndLead) === null || _$ref6 === void 0 ? void 0 : _$ref6.whiteWrapper)) {
        textColor = "dark";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(FormWrapper, {
        $textColor: textColor,
        tabIndex: 0,
        ref: ref,
        "data-embedded-funnel": true,
        name: "step" in state.qualification ? state.qualification.step.id : state.status,
        onSubmit: function(e) {
            e.preventDefault();
            toNextStep();
        },
        onKeyPressCapture: onKeyPress,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                position: "absolute",
                top: "-120px",
                ref: scrollHelperRef
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                width: "100%",
                pb: 6,
                children: [
                    state.status === qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.answering */ .w.answering && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(shared_components_EmbeddedFunnel_EmbeddedQuestion__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        slides: slides,
                        step: state.qualification.step,
                        highlightColor: highlightColor,
                        ratings: ratings,
                        renderTitle: renderTitle,
                        LayoutComponent: LayoutComponent,
                        titleTranslationKeys: titleTranslationKeys
                    }),
                    state.status === qualification_context_model__WEBPACK_IMPORTED_MODULE_6__/* .QUALIFICATION_STATUS.answered */ .w.answered && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(shared_components_EmbeddedFunnel_LoadingIndicator__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                variant: onBackground === "dark" ? "light" : "dark"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                                display: "none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EmbeddedRequestPage, {
                                    ratings: ratings
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].form */ .ZP.form(_templateObject(), function(param) {
    var $textColor = param.$textColor;
    return $textColor === "light" ? "white" : "rgb(60, 67, 64)";
});
/* harmony default export */ __webpack_exports__["Z"] = (EmbeddedFunnel);


/***/ }),

/***/ 88710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85444);
/* harmony import */ var shared_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41210);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow: auto;\n  display: flex;\n  gap: ",
        "px;\n  margin: 0 auto;\n\n  ",
        " {\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    ::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  background-color: white;\n  border-color: white;\n  transform: ",
        ";\n\n  ",
        " {\n    width: 55px;\n    height: 55px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: ",
        "px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      left: ",
        "px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: ",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      bottom: ",
        "px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: 0;\n      bottom: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  display: none;\n  z-index: 11;\n  right: ",
        ";\n  left: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  \n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    display: block;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    width: 88px;\n    height: 100%;\n    right: ",
        ";\n    left: ",
        ";\n    top: 0;\n    position: absolute;\n    pointer-events: none;\n    bottom: 0;\n    z-index: 10;\n    background: linear-gradient(\n      270deg,\n      #ffffff 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var DEFAULT_SCROLL_AMOUNT_IN_PIXEL = 300;
var FullWidthSlider = function(_param) {
    var children = _param.children, _scrollAmount = _param.scrollAmount, scrollAmount = _scrollAmount === void 0 ? DEFAULT_SCROLL_AMOUNT_IN_PIXEL : _scrollAmount, scrollButtonOffset = _param.scrollButtonOffset, _gap = _param.gap, gap = _gap === void 0 ? 3 : _gap, wrapperBoxProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "scrollAmount",
        "scrollButtonOffset",
        "gap"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isScrollable = ref1[0], setScrollable = ref1[1];
    var ref2 = (0,shared_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)(), windowWidth = ref2.width;
    var buttonTopOffset = scrollButtonOffset && "top" in scrollButtonOffset && scrollButtonOffset.top;
    var buttonBottomOffset = scrollButtonOffset && "bottom" in scrollButtonOffset && scrollButtonOffset.bottom;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref1, ref2, ref3;
        var isCurrentlyScrollable = (ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight) ? ((ref2 = ref.current) === null || ref2 === void 0 ? void 0 : ref2.scrollWidth) > ((ref3 = ref.current) === null || ref3 === void 0 ? void 0 : ref3.clientWidth) : true;
        setScrollable(isCurrentlyScrollable);
    }, [
        windowWidth
    ]);
    var createScrollHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(direction) {
        return function() {
            var element = ref.current;
            if (!element) {
                return;
            }
            var scrollLeft = element.scrollLeft;
            element.scrollTo({
                left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
                behavior: "smooth"
            });
        };
    }, [
        scrollAmount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhiteFade, {
                position: "left"
            }),
            isScrollable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButtonWrapper, {
                bottom: buttonBottomOffset || 0,
                top: buttonTopOffset || 0,
                position: "left",
                left: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
                    direction: "left",
                    onClick: createScrollHandler("left")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                justifyContent: isScrollable ? "start" : "center",
                px: 2,
                gap: gap,
                ref: ref
            }, wrapperBoxProps), {
                children: children
            })),
            isScrollable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButtonWrapper, {
                bottom: buttonBottomOffset || 0,
                top: buttonTopOffset || 0,
                right: 0,
                position: "right",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
                    direction: "right",
                    onClick: createScrollHandler("right")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhiteFade, {
                position: "right"
            })
        ]
    });
};
var ScrollableSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? gap * 8 : 0;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ScrollButton = function(param) {
    var onClick = param.onClick, direction = param.direction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircularButton, {
        flip: direction === "left",
        variant: "tertiary",
        rounded: true,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
    });
};
var CircularButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx)(_templateObject1(), function(param) {
    var flip = param.flip;
    return flip && "rotate(-180deg)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var ScrollButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject7(), function(param) {
    var position = param.position;
    return position === "right" ? "-80px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "-80px" : "none";
}, function(param) {
    var top = param.top;
    return top && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject2(), top);
}, function(param) {
    var left = param.left;
    return (left !== null || left !== undefined) && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject3(), left);
}, function(param) {
    var right = param.right;
    return (right !== null || right !== undefined) && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject4(), right);
}, function(param) {
    var bottom = param.bottom;
    return bottom && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject5(), bottom);
}, function(param) {
    var top = param.top, bottom = param.bottom;
    return !bottom && !top && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject6());
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 4);
});
var WhiteFade = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var position = param.position;
    return position === "right" ? "-60px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "-60px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "rotate(-180deg)" : "none";
});
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSlider);


/***/ }),

/***/ 96917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timeout = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 41210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useWindowSize = function() {
    var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)( true ? {
        width: window.innerWidth,
        height: window.innerHeight
    } : 0), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var resizeTimeout;
        var handleResize = function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }, delay);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            clearTimeout(resizeTimeout);
            window.removeEventListener("resize", handleResize);
        };
    }, [
        delay
    ]);
    return windowSize;
};


/***/ }),

/***/ 91902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ webToLeadRequest; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./src/lib/bugsnag.js
var bugsnag = __webpack_require__(45817);
;// CONCATENATED MODULE: ./src/shared/helpers/fetchWithRetry.js


var fetchWithRetry = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, options) {
        var retry, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retry = options && options.retry || 3;
                    _state.label = 1;
                case 1:
                    if (!(retry > 0)) return [
                        3,
                        8
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    e = _state.sent();
                    if (options && options.callback) {
                        options.callback(retry);
                    }
                    retry = retry - 1;
                    if (retry === 0) {
                        throw e;
                    }
                    if (!(options && options.pause)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        sleep(options.pause)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        3,
                        1
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, options) {
        return _ref.apply(this, arguments);
    };
}();
function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}

;// CONCATENATED MODULE: ./src/shared/services/webToLeadRequest.js





function webToLeadRequest() {
    return _webToLeadRequest.apply(this, arguments);
}
function _webToLeadRequest() {
    _webToLeadRequest = (0,_async_to_generator/* default */.Z)(function() {
        var payload, webToLeadData, body, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            payload = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, webToLeadData = _arguments.length > 1 ? _arguments[1] : void 0;
            body = query_string.stringify(webToLeadData(payload));
            response = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    fetchWithRetry("https://heycater.my.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8", {
                                        method: "POST",
                                        mode: "no-cors",
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded"
                                        },
                                        body: body,
                                        retry: 2,
                                        pause: 1500
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                bugsnag/* default.notify */.Z.notify(new Error("[Error trying to submit Salesforce webToLeadRequest:\n            dataFromFunnel: ".concat(JSON.stringify(payload), "\n            webToLeadData: ").concat(JSON.stringify(body), "\n            error: ").concat(JSON.stringify(error))));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function response() {
                    return _ref.apply(this, arguments);
                };
            }();
            return [
                2,
                response()
            ];
        });
    });
    return _webToLeadRequest.apply(this, arguments);
}


/***/ }),

/***/ 66442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QualityAndSafetyIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62087);






function QualityAndSafetyIcon(_param) {
    var size = _param.size, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 595.28 595.28",
        height: size,
        width: size
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#f28c0b",
                d: "M396.58 394.93a57 57 0 01-29.35 7h-7.8l-52.14 121.26L337 592.4a4.74 4.74 0 008.72 0l37.08-95.77 94.93 39.1a4.74 4.74 0 006.14-6.2L417 373.54a56.75 56.75 0 01-20.42 21.39zM283.8 425.12c-17.91 0-31.3-9.48-41.82-17.08a62.65 62.65 0 00-11.78-7 17.36 17.36 0 00-4.25-.35 58.71 58.71 0 00-10.46.63c-4.74.42-9.62.83-14.84.83a56.92 56.92 0 01-29.35-7 48.32 48.32 0 01-8.08-5.92L103 529.39a4.74 4.74 0 002.59 6.18 4.69 4.69 0 003.55 0l94.93-39.1 37.08 95.77a4.74 4.74 0 008.72 0l80-186.94-3.87 3.09c-10.9 6.97-24.29 16.73-42.2 16.73zM283.93 61.25A139.57 139.57 0 10423.5 200.82 139.57 139.57 0 00283.93 61.25z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#f28c0b",
                d: "M460.14 248.11c4.25-15.75 23.42-30.11 23.42-47.26s-19.24-31.43-23.42-47.26 4.95-38.33-3.27-52.62S424.66 83.61 413 71.83s-14.63-35.55-29.13-44-36.32 1-52.63-3.28S301.08 1.15 284 1.15s-31.43 19.17-47.25 23.42-38.34-4.95-52.63 3.28-17.36 32.2-29.14 44-35.54 14.62-43.91 29.15 1.05 36.31-3.34 52.62-23.42 30.08-23.42 47.23 19.16 31.44 23.42 47.19-5 38.34 3.34 52.63S143.21 318 155 329.8s14.64 35.55 29.14 43.91 36.32-1 52.63 3.35 30.11 23.42 47.25 23.42 31.44-19.24 47.19-23.42 38.34 4.95 52.63-3.28 17.35-32.2 29.13-43.91 35.55-14.64 44-29.14-1.15-36.31 3.17-52.62zm-176.21 112.5a159.69 159.69 0 11159.69-159.69 159.85 159.85 0 01-159.69 159.69z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M352.39 161.53c-.19 4.27-.33 8.53-.56 12.78q-.45 8.16-1.65 16.25A113.85 113.85 0 01325.45 248a151.67 151.67 0 01-17.08 17.76 217.94 217.94 0 01-20.61 16.12 6.38 6.38 0 01-7.63 0 209.36 209.36 0 01-23.86-19.06 140.24 140.24 0 01-17.44-19.49 110.8 110.8 0 01-17.3-35 130.06 130.06 0 01-3.66-16.67c-.58-3.76-1-7.54-1.37-11.33-.88-9.58-1-19.19-1.06-28.8a6.56 6.56 0 015.33-6.5 143 143 0 0025.93-7.7 180.28 180.28 0 0028.3-14.25c1.72-1.06 3.39-2.19 5.07-3.3a6.83 6.83 0 013.9-1.25 6.5 6.5 0 013.62 1.15 155 155 0 0013.65 8.32 171.69 171.69 0 0034.16 14.24c3.87 1.12 7.79 2 11.74 2.83a6.42 6.42 0 015.29 6.45v5.07c0 1.69-.04 3.28-.04 4.94zm-68.45-28.78a185 185 0 01-55.59 23.82v.89c.11 4.33.17 8.67.34 13 .13 3.09.33 6.19.61 9.28.38 4.24.89 8.47 1.63 12.67a121.09 121.09 0 002.71 12 96.44 96.44 0 0012 26.39 120.37 120.37 0 0018.24 21.54 188.31 188.31 0 0019.45 16c.2.15.41.28.6.41l.37-.25a194.11 194.11 0 0018.15-14.72 130.18 130.18 0 0015.66-17.11 97.45 97.45 0 0016.87-35 133.69 133.69 0 003.52-21.3c.36-3.89.58-7.8.75-11.7s.17-7.57.25-11.35v-.71a184.15 184.15 0 01-55.56-23.86z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M280 207.13c.21-.26.37-.5.56-.69l32.21-32.23.76-.73a4.46 4.46 0 015.9-.15c2.06 1.85 4 3.82 5.89 5.87a4.55 4.55 0 010 5.74 10.55 10.55 0 01-.72.78l-40.93 40.94a5 5 0 01-4.28 1.62 4.55 4.55 0 01-2.74-1.32l-3.65-3.54-19.88-19.51a5.15 5.15 0 01-1.6-2.76 4.47 4.47 0 011.16-4.06c1.65-1.74 3.35-3.43 5-5.14a4.86 4.86 0 016.85.06c4.92 4.9 9.9 9.73 14.85 14.58z"
            })
        ]
    }));
}


/***/ }),

/***/ 6029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FooterLinks; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89659);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85444);
/* harmony import */ var system_components_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10758);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function FooterLinks(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("static_pages").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var cities = [
        {
            key: "berlin",
            link: "berlin"
        },
        {
            key: "muenchen",
            link: "muenchen"
        },
        {
            key: "hamburg",
            link: "hamburg"
        },
        {
            key: "frankfurt-am-main",
            link: "frankfurt"
        },
        {
            key: "duesseldorf",
            link: "duesseldorf"
        },
        {
            key: "koeln",
            link: "koeln"
        },
        {
            key: "leipzig",
            link: "leipzig"
        },
        {
            key: "hannover",
            link: "hannover"
        }, 
    ];
    var countries = [
        "austria",
        "germany",
        "switzerland"
    ];
    var countriesLinksMapping = {
        switzerland: "schweiz",
        germany: "deutschland",
        austria: "oesterreich"
    };
    var cateringCategories = [
        {
            key: "fingerfood",
            url: "/fingerfood"
        },
        {
            key: "breakfast",
            url: "/fruehstueck"
        },
        {
            key: "foodTruck",
            url: "/food-truck"
        },
        {
            key: "event",
            url: "/event"
        },
        {
            key: "buffet",
            url: "/buffet"
        },
        {
            key: "cocktail",
            url: "/bar-cocktail"
        },
        {
            key: "coffee",
            url: "/mobile-kaffeebar"
        },
        {
            key: "vegan",
            url: "/vegan"
        },
        {
            key: "bbq",
            url: "/grill-catering"
        },
        {
            key: "summer_party",
            url: "/sommerfest"
        },
        {
            key: "company_party",
            url: "/catering-firmenfeier"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "nav"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            pb: 2,
            pt: 4,
            id: "footerLinksSection",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mb: 3,
                            children: t("footerLinks.cateringCategories")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: cateringCategories.map(function(category) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale).concat(category.url),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("footerLinks.categories.".concat(category.key))
                                            })
                                        })
                                    }, category.key);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mt: 5,
                            mb: 3,
                            children: t("footerLinks.cities")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: cities.map(function(city) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale, "/catering-").concat(city.link),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("footerLinks.cateringIn", {
                                                    city: t("common:cities.".concat(city.key))
                                                })
                                            }, city.key)
                                        })
                                    }, city.link);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mt: 5,
                            mb: 3,
                            children: t("footerLinks.countries")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: countries.map(function(country) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale, "/catering-").concat(countriesLinksMapping[country]),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("common:countries.".concat(country))
                                            }, country)
                                        })
                                    }, country);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
var StyledGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject(), function(props) {
    return props.theme.spacing(0, 0, 0, 1);
});


/***/ }),

/***/ 59593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 158%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #76a334;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: inherit;\n  color: inherit;\n  width: ",
        "px;\n\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.9);\n    transform: scale(1.1);\n  }\n\n  &:hover .card-title {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  position: relative;\n  width: 280px;\n  height: 210px;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  padding: ",
        ";\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var CARD_WIDTH = 280;
function ImageCard(param) {
    var href = param.href, ctaHighlight = param.ctaHighlight, cta = param.cta, imageSrc = param.imageSrc, pillText = param.pillText, _ctaTextAlign = param.ctaTextAlign, ctaTextAlign = _ctaTextAlign === void 0 ? "center" : _ctaTextAlign;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("dynamic_landing_page").t;
    var WrapperComponent = href ? (next_link__WEBPACK_IMPORTED_MODULE_5___default()) : react__WEBPACK_IMPORTED_MODULE_2__.Fragment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapperComponent, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledLink, {
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                alt: "",
                                src: imageSrc,
                                objectFit: "cover",
                                width: CARD_WIDTH,
                                height: 210
                            })
                        }),
                        pillText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPill, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                lineHeight: 1,
                                variant: "caption",
                                textAlign: true,
                                children: pillText
                            })
                        })
                    ]
                }),
                cta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    pt: 1.5,
                    textAlign: ctaTextAlign,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TypographyCTA, {
                            component: "span",
                            className: "card-title",
                            children: cta ? cta : t("CTA")
                        }),
                        ctaHighlight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypographyCompany, {
                            className: "card-title",
                            component: "span",
                            children: [
                                " ",
                                ctaHighlight
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
}
var TypographyCTA = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT)(_templateObject());
var TypographyCompany = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(TypographyCTA)(_templateObject1());
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].a */ .ZP.a(_templateObject2(), CARD_WIDTH);
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject3(), function(props) {
    return props.theme.spacing(1.5);
});
var StyledPill = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject4(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5, 1);
}, function(props) {
    return props.theme.spacing(8);
});
/* harmony default export */ __webpack_exports__["Z"] = (ImageCard);


/***/ }),

/***/ 73743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_components_FullWidthSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88710);
/* harmony import */ var static_pages_components_ImageCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59593);




var ImageCardSlider = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components_FullWidthSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        scrollButtonOffset: {
            top: 80
        },
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(static_pages_components_ImageCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                href: item.href,
                cta: item.cta,
                ctaHighlight: item.ctaHighlight,
                pillText: item.pillText,
                imageSrc: item.imageSrc,
                ctaTextAlign: item.ctaTextAlign
            }, item.key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageCardSlider);


/***/ }),

/***/ 57844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QuotationMark; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function QuotationMark() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "78",
        height: "49",
        viewBox: "0 0 78 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            opacity: "0.3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M31.2917 13.5743C31.2917 21.2995 29.1299 28.3074 24.8064 34.598C20.4828 40.8885 14.5379 45.6892 6.97173 49L6.16106 46.0203C10.5927 44.1441 14.592 41.2196 18.1589 37.2466C21.7258 33.2737 23.6714 28.6385 23.9957 23.3412C22.4825 24.9966 20.753 26.2658 18.8074 27.1486C16.8619 28.0315 14.8082 28.473 12.6464 28.473C4.21546 28.473 0 24.8311 0 17.5473C0 14.1261 0.756621 11.0912 2.26986 8.44257C3.8912 5.79391 6.05297 3.75225 8.75519 2.31757C11.5655 0.772523 14.7001 0 18.1589 0C22.2663 0 25.4549 1.04842 27.7248 3.14527C30.1027 5.24212 31.2917 8.71847 31.2917 13.5743Z",
                    fill: "#9CBA6C"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M78 13.5743C78 21.2995 75.8382 28.3074 71.5147 34.598C67.1911 40.8885 61.2462 45.6892 53.68 49L52.8694 46.0203C57.301 44.1441 61.3003 41.2196 64.8672 37.2466C68.4341 33.2737 70.3797 28.6385 70.704 23.3412C69.1908 24.9966 67.4613 26.2658 65.5157 27.1486C63.5701 28.0315 61.5165 28.473 59.3547 28.473C50.9238 28.473 46.7083 24.8311 46.7083 17.5473C46.7083 14.1261 47.4649 11.0912 48.9782 8.44257C50.5995 5.79391 52.7613 3.75225 55.4635 2.31757C58.2738 0.772523 61.4084 0 64.8672 0C68.9746 0 72.1632 1.04842 74.4331 3.14527C76.811 5.24212 78 8.71847 78 13.5743Z",
                    fill: "#9CBA6C"
                })
            ]
        })
    });
}


/***/ }),

/***/ 23288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function FooterClean(param) {
    var title = param.title, cta = param.cta, link = param.link;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)("static_pages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBox, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: {
            xs: 2,
            sm: 5
        },
        pb: {
            xs: 5,
            sm: 7
        },
        px: {
            xs: 3,
            sm: 10,
            md: 20
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                variant: "h3",
                py: 4,
                textAlign: "center",
                children: t(title)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                size: "lg",
                variant: "primary",
                as: "a",
                href: link,
                target: "_blank",
                rel: "noopener",
                rounded: true,
                children: t(cta)
            })
        ]
    });
}
var StyledBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject(), function(props) {
    return props.theme.colors.heroGradient;
});
/* harmony default export */ __webpack_exports__["Z"] = (FooterClean);


/***/ }),

/***/ 24085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PartnersCTA; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./src/shared/components/ScrollToTopButton.js
var ScrollToTopButton = __webpack_require__(42124);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/PartnerLogoBubbles.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 140px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #ffffff;\n  width: 120px;\n\n  ",
        " {\n    margin-left: -",
        "px;\n    margin-right: -",
        "px;\n    box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);\n    border-radius: 50%;\n    width: 140px;\n  }\n\n  ",
        " {\n    margin-left: ",
        "px;\n    margin-right: ",
        "px;\n    margin-bottom: ",
        "px;\n    box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);\n    border-radius: 500px;\n    width: 140px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PARTNERS = {
    logos: [
        {
            src: "/artifacts/images/marketing_pages/barmer.webp",
            height: 16,
            alt: "Barmer"
        },
        {
            src: "/artifacts/images/marketing_pages/hellofresh.webp",
            height: 48,
            alt: "HelloFresh"
        },
        {
            src: "/artifacts/images/marketing_pages/audi.webp",
            height: 36,
            alt: "Audi"
        },
        {
            src: "/artifacts/images/marketing_pages/infarm.webp",
            height: 24,
            alt: "Infarm"
        },
        {
            src: "/artifacts/images/marketing_pages/ebay.webp",
            height: 40,
            alt: "Ebay"
        },
        {
            src: "/artifacts/images/marketing_pages/dell.webp",
            height: 100,
            alt: "Dell"
        }, 
    ]
};
function PartnerLogoBubbles() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        display: "flex",
        justifyContent: "center",
        py: 4,
        flexWrap: "wrap",
        sm: {
            flexWrap: "no-wrap",
            py: 4
        },
        children: PARTNERS.logos.map(function(partner) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerBubble, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "img-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        alt: ""
                    }, partner), {
                        width: 100
                    }))
                })
            }, partner.alt);
        })
    });
}
var PartnerBubble = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), function(props) {
    return props.theme.breakpoints.up("md");
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
});
/* harmony default export */ var components_PartnerLogoBubbles = (PartnerLogoBubbles);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/PartnersCTA.js








function PartnersCTA() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        py: 4,
        sm: {
            pt: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            size: "sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                    as: "header",
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Typography */.ZT, {
                            variant: "h3",
                            mb: 2,
                            children: [
                                t("marketingPages.partnersCTA.title.a"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                    variant: "inherit",
                                    slab: true,
                                    color: "secondary",
                                    children: t("marketingPages.partnersCTA.title.b")
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            variant: "subtitle2",
                            children: t("marketingPages.partnersCTA.subtitle")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PartnerLogoBubbles, {}),
                mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    pt: {
                        xs: 2,
                        sm: 4
                    },
                    pb: 2,
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTopButton/* default */.Z, {
                        children: t("common:labels.findCaterers")
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_PartnersCTA = (PartnersCTA);


/***/ }),

/***/ 84332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ AreaWithSidebarCTA; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39138);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_truncate__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70131);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85444);
/* harmony import */ var shared_components_FlexBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85249);
/* harmony import */ var shared_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98769);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: currentColor;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  font-size: 14px;\n  text-decoration: none;\n  text-align: center;\n  display: block;\n  white-space: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var TOP_OFFSET = 170;
var PAGE_CONTENT_WIDTH = "720px";
var CTA_IMAGE_NEGATIVE_MARGIN = 8;
var Sidebar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var title = param.title, subtitle = param.subtitle, ctaText = param.ctaText, url = param.url, isVisible = param.isVisible, _width = param.width, width = _width === void 0 ? 230 : _width, _rightPadding = param.rightPadding, rightPadding = _rightPadding === void 0 ? "40px" : _rightPadding;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("static_pages").t;
    var ctaButtonText = lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default()(ctaText ? ctaText : t("marketingPages.sidebar.cta"), {
        length: 100
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CTAWrapperBox, {
        as: "aside",
        ref: ref,
        borderRadius: "8px",
        visibility: isVisible ? "visible" : "hidden",
        position: "fixed",
        top: TOP_OFFSET + CTA_IMAGE_NEGATIVE_MARGIN * SPACING_MULTIPLIER,
        pb: 2,
        left: "calc((100vw - ".concat(PAGE_CONTENT_WIDTH, ") / 2 - ").concat(width, "px - ").concat(rightPadding, ")"),
        width: width,
        display: {
            xs: "none",
            lg: "block"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mt: -CTA_IMAGE_NEGATIVE_MARGIN,
                textAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    alt: "",
                    src: "/artifacts/images/marketing_pages/catering_cta_image.webp",
                    height: 162,
                    width: 199
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                variant: "h2",
                component: "h3",
                align: "center",
                px: 2,
                mt: 2,
                fontSize: "24px",
                children: title ? title : t("marketingPages.sidebar.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                variant: "body1",
                mt: 3,
                px: 2,
                align: "center",
                fontWeight: "500",
                mb: 3,
                children: subtitle ? subtitle : t("marketingPages.sidebar.body")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(shared_components_FlexBox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                alignItems: "center",
                flexDirection: "column",
                px: 2,
                mt: 2,
                gap: 2,
                children: [
                    url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                        as: "a",
                        size: "lg",
                        rounded: true,
                        href: url,
                        id: "sidebar-cta",
                        mt: 2,
                        children: ctaButtonText
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                        rounded: true,
                        size: "lg",
                        onClick: function() {
                            return window.scroll({
                                top: 0,
                                behavior: "smooth"
                            });
                        },
                        id: "sidebar-cta",
                        children: ctaButtonText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PhoneLink, {
                        href: shared_constants__WEBPACK_IMPORTED_MODULE_7__/* .CONTACT_PHONE.href */ .Y.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            fontSize: "12px",
                            children: shared_constants__WEBPACK_IMPORTED_MODULE_7__/* .CONTACT_PHONE.formatted */ .Y.formatted
                        })
                    })
                ]
            })
        ]
    });
});
Sidebar.displayName = "Sidebar";
var SPACING_MULTIPLIER = 8;
var PhoneLink = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].a */ .ZP.a(_templateObject());
var CTAWrapperBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject1(), function(props) {
    return props.theme.colors.heroGradient;
});
/**
 * Wraps an area, where the sidebar will be shown.
 */ var AreaWithSidebarCTA = function(param) {
    var children = param.children, title = param.title, subtitle = param.subtitle, ctaText = param.ctaText, url = param.url, _topPadding = param.topPadding, topPadding = _topPadding === void 0 ? 2 : _topPadding, _bottomPadding = param.bottomPadding, bottomPadding = _bottomPadding === void 0 ? 5 : _bottomPadding;
    var ref, ref1;
    var ref2 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_10__/* .useInView */ .YD)({
        threshold: 1
    }), startRef = ref2.ref, startEntry = ref2.entry;
    var ref3 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_10__/* .useInView */ .YD)({
        threshold: 1
    }), endRef = ref3.ref, endEntry = ref3.entry;
    var startNodePosition = getNodePosition(startEntry);
    var endNodePosition = getNodePosition(endEntry);
    var isBetweenPoints = startNodePosition === "over-viewport" && endNodePosition === "under-viewport";
    var sidebarRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var sidebarBottom = (ref1 = (ref = sidebarRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.bottom;
    var bottomOffset =  true ? window.innerHeight - sidebarBottom : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                position: "relative",
                top: "-".concat(TOP_OFFSET - topPadding * SPACING_MULTIPLIER, "px"),
                ref: startRef
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Sidebar, {
                ref: sidebarRef,
                isVisible: isBetweenPoints,
                title: title,
                subtitle: subtitle,
                ctaText: ctaText,
                url: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                position: "relative",
                bottom: "-".concat(bottomOffset - bottomPadding * SPACING_MULTIPLIER, "px"),
                ref: endRef
            })
        ]
    });
};
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx)(_templateObject2());
function getNodePosition(observerEntry) {
    if (!(observerEntry === null || observerEntry === void 0 ? void 0 : observerEntry.rootBounds)) {
        return;
    }
    if (observerEntry.isIntersecting) {
        return "in-viewport";
    } else {
        if (observerEntry.boundingClientRect.top > observerEntry.rootBounds.bottom) {
            return "under-viewport";
        } else {
            return "over-viewport";
        }
    }
}


/***/ }),

/***/ 84934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_icons_Star__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85984);
/* harmony import */ var _material_ui_icons_StarBorder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83817);
/* harmony import */ var _material_ui_icons_StarHalf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74419);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26793);







function NoRatings() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)("static_pages").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        display: "inline-flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
            variant: "body2",
            sm: {
                textAlign: "center"
            },
            fontSize: 14,
            children: t("catererCards.noReviewsYet")
        })
    });
}
var HIGHEST_SCORE = 5;
function Rating(param) {
    var _score = param.score, score = _score === void 0 ? 0 : _score, isRated = param.isRated;
    var i18n = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().i18n;
    var formatNumberForLocale = function(number) {
        return number.toLocaleString(i18n.languages[0], {
            minimumFractionDigits: 1
        });
    };
    var normalizedScore = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return score / 10;
    }, [
        score
    ]);
    var filledStarsArray = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return Array.from({
            length: Math.floor(normalizedScore)
        });
    }, [
        normalizedScore
    ]);
    var emptyStarsArray = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return Array.from({
            length: Math.floor(HIGHEST_SCORE - normalizedScore)
        });
    }, [
        normalizedScore
    ]);
    if (!isRated) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoRatings, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        display: "flex",
        lineHeight: 0,
        minWidth: "147px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                marginRight: 1,
                display: "flex",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                    variant: "body1",
                    fontSize: 14,
                    children: formatNumberForLocale(normalizedScore)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                children: [
                    filledStarsArray.map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Star__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            color: "secondary",
                            fontSize: "small"
                        }, index);
                    }),
                    normalizedScore % 1 !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_StarHalf__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        color: "secondary",
                        fontSize: "small"
                    }),
                    emptyStarsArray.map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_StarBorder__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            color: "secondary",
                            fontSize: "small"
                        }, index);
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Rating);


/***/ }),

/***/ 97010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopCaterersCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChevronRight.js
var ChevronRight = __webpack_require__(66735);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/hooks/useLocalizeCity.js
var useLocalizeCity = __webpack_require__(9988);
// EXTERNAL MODULE: ./src/shared/hooks/useLocalizedFieldName.js
var useLocalizedFieldName = __webpack_require__(25734);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(62087);
;// CONCATENATED MODULE: ./src/shared/svg/Delivery.js





function Delivery(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 18 16"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 1.25C0 0.835786 0.335786 0.5 0.75 0.5H12C12.4142 0.5 12.75 0.835786 12.75 1.25V11C12.75 11.4142 12.4142 11.75 12 11.75H0.75C0.335786 11.75 0 11.4142 0 11V1.25ZM1.5 2V10.25H11.25V2H1.5Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.25 5C11.25 4.58579 11.5858 4.25 12 4.25H15C15.1989 4.25 15.3897 4.32902 15.5303 4.46967L17.7803 6.71967C17.921 6.86032 18 7.05109 18 7.25V11C18 11.4142 17.6642 11.75 17.25 11.75H12C11.5858 11.75 11.25 11.4142 11.25 11V5ZM12.75 5.75V10.25H16.5V7.56066L14.6893 5.75H12.75Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.125 11.75C3.50368 11.75 3 12.2537 3 12.875C3 13.4963 3.50368 14 4.125 14C4.74632 14 5.25 13.4963 5.25 12.875C5.25 12.2537 4.74632 11.75 4.125 11.75ZM1.5 12.875C1.5 11.4253 2.67525 10.25 4.125 10.25C5.57475 10.25 6.75 11.4253 6.75 12.875C6.75 14.3247 5.57475 15.5 4.125 15.5C2.67525 15.5 1.5 14.3247 1.5 12.875Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.875 11.75C13.2537 11.75 12.75 12.2537 12.75 12.875C12.75 13.4963 13.2537 14 13.875 14C14.4963 14 15 13.4963 15 12.875C15 12.2537 14.4963 11.75 13.875 11.75ZM11.25 12.875C11.25 11.4253 12.4253 10.25 13.875 10.25C15.3247 10.25 16.5 11.4253 16.5 12.875C16.5 14.3247 15.3247 15.5 13.875 15.5C12.4253 15.5 11.25 14.3247 11.25 12.875Z"
            })
        ]
    }));
}

;// CONCATENATED MODULE: ./src/shared/svg/LeadTime.js





function LeadTime(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "18",
        height: "17",
        viewBox: "0 0 18 17",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.00016 2.12504C5.47935 2.12504 2.62516 4.97923 2.62516 8.50004C2.62516 12.0209 5.47935 14.875 9.00016 14.875C12.521 14.875 15.3752 12.0209 15.3752 8.50004C15.3752 4.97923 12.521 2.12504 9.00016 2.12504ZM1.2085 8.50004C1.2085 4.19682 4.69694 0.708374 9.00016 0.708374C13.3034 0.708374 16.7918 4.19682 16.7918 8.50004C16.7918 12.8033 13.3034 16.2917 9.00016 16.2917C4.69694 16.2917 1.2085 12.8033 1.2085 8.50004Z",
                fill: "#007F33"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.00016 3.54171C9.39136 3.54171 9.7085 3.85884 9.7085 4.25004V8.06227L12.1503 9.28315C12.5002 9.45811 12.642 9.88358 12.467 10.2335C12.2921 10.5834 11.8666 10.7252 11.5167 10.5503L8.68339 9.13359C8.44341 9.01361 8.29183 8.76834 8.29183 8.50004V4.25004C8.29183 3.85884 8.60896 3.54171 9.00016 3.54171Z",
                fill: "#007F33"
            })
        ]
    }));
}

// EXTERNAL MODULE: ./src/shared/svg/QualityAndSafetyIcon.tsx
var QualityAndSafetyIcon = __webpack_require__(66442);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/Rating.js
var Rating = __webpack_require__(84934);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/TopCaterersCard.js



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  box-shadow: 0px 4px 40px rgba(62, 41, 29, 0.08);\n  border-radius: ",
        "px;\n\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.85);\n    transform: scale(1.1);\n  }\n\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: inherit;\n  color: inherit;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  &:hover .btn-caterer {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: 200px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  padding: ",
        ";\n  min-height: 145px;\n  ",
        " {\n    min-height: 160px;\n  }\n  ",
        " {\n    min-height: fit-content;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 40px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: black;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 172.5%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  margin: ",
        ";\n  height: 18px;\n  width: 0px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 42px;\n  border-radius: 0px;\n  font-size: 14px;\n\n  & > .btn-caterer__icon {\n    position: relative;\n    transition: ",
        ";\n    right: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: ",
        "px;\n\n  ",
        " {\n    display: flex;\n    align-items: start;\n    flex-direction: column;\n  }\n  ",
        " {\n    display: inline;\n    align-items: center;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-bottom: ",
        "px;\n  }\n  ",
        " {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: ",
        "px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  min-height: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  padding: ",
        ";\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}















var CARD_WIDTH = 280;
function TopCaterersCard(param) {
    var caterer = param.caterer, providedCity = param.city;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var localizedFieldAlgolia = (0,useLocalizedFieldName/* default */.Z)().localizedFieldAlgolia;
    var city = providedCity || caterer.cities[0];
    var localizedCity = (0,useLocalizeCity/* useLocalizedCity */.Qu)(city);
    var url = (0,urls/* marketplaceURL */.j5)("/catering/".concat((0,cities/* findCitySlug */.r$)(city), "/").concat(caterer.slug));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
        href: url,
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopCaterersCard, {
            as: "article",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                            children: caterer.profile_image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "",
                                height: 200,
                                width: CARD_WIDTH,
                                src: caterer.profile_image,
                                objectFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPill, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                lineHeight: 1,
                                variant: "caption",
                                children: localizedCity
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CatererInformationWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CatererInformation, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitleTypography, {
                                children: caterer.company_name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SloganTypography, {
                            variant: "body2",
                            children: caterer[localizedFieldAlgolia("slogan")]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                            display: "flex",
                            alignItems: "center",
                            my: 1.5,
                            mb: 2,
                            children: [
                                caterer.quality_safety_rating === "Quality Proven Partner" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QualityAndSafetyIcon/* default */.Z, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                    score: caterer.rating_score,
                                    isRated: caterer.is_rated
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliverInfoContainer, {
                            display: "inline",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliveryBox, {
                                    display: "inline-flex",
                                    fontSize: 18,
                                    ml: 0.2,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Delivery, {
                                            htmlColor: "#537124",
                                            fontSize: "inherit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                            variant: "caption",
                                            fontSize: 12,
                                            ml: 1,
                                            mr: 1.5,
                                            children: caterer.minimum_delivery_fee === 0 ? t("catererCards.freeDelivery", {
                                                amount: wholeNumberWithCurrencySymbol(caterer.minimum_delivery_fee)
                                            }) : t("catererCards.delivery", {
                                                amount: wholeNumberWithCurrencySymbol(caterer.minimum_delivery_fee)
                                            })
                                        })
                                    ]
                                }),
                                caterer.numeric_lead_time && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    fontSize: 18,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadTime, {
                                            htmlColor: "#537124",
                                            fontSize: "inherit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                            variant: "caption",
                                            ml: 1,
                                            children: t("catererCards.leadTime", {
                                                days: caterer.numeric_lead_time,
                                                count: caterer.numeric_lead_time
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CatererFooter, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink, {
                        size: "lg",
                        rounded: false,
                        variant: "tertiary",
                        className: "btn-caterer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "btn-caterer__copy",
                                children: t("catererCards.seeCaterer")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                className: "btn-caterer__icon"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function wholeNumberWithCurrencySymbol(number) {
    return "".concat(Math.floor(number / 100), "€");
}
var InfoTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.grey.secondary;
});
var StyledTopCaterersCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), CARD_WIDTH, function(props) {
    return props.theme.spacing(1.5);
});
var StyledLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.grey[600];
}, function(param) {
    var theme = param.theme;
    return theme.palette.common.white;
});
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var CatererInformation = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), function(props) {
    return props.theme.spacing(2);
});
var CatererInformationWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5(), function(props) {
    return props.theme.spacing(0, 2);
}, function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var TruncatedTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject6());
var CardTitleTypography = (0,styled_components_browser_esm/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedTypography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        variant: "h4",
        component: "h3",
        fontSize: "18px"
    }));
})(_templateObject7());
var Divider = styled_components_browser_esm/* default.div */.ZP.div(_templateObject8(), function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.spacing(0, 2, 0, 1.5);
});
var ButtonLink = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(_templateObject9(), function(props) {
    return props.theme.transitions.create("right", {
        duration: "250ms"
    });
});
var DeliverInfoContainer = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject10(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var DeliveryBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject11(), function(props) {
    return props.theme.breakpoints.down("md");
}, function(props) {
    return props.theme.spacing(0.5);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0);
});
var CatererFooter = styled_components_browser_esm/* default.footer */.ZP.footer(_templateObject12(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var SloganTypography = (0,styled_components_browser_esm/* default */.ZP)(TruncatedTypography)(_templateObject13(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5);
});
var StyledPill = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject14(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5, 1);
}, function(props) {
    return props.theme.spacing(8);
});


/***/ }),

/***/ 36926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopCaterers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/shared/components/Dots.tsx
var Dots = __webpack_require__(90848);
// EXTERNAL MODULE: ./src/shared/hooks/usePagination.ts + 1 modules
var usePagination = __webpack_require__(98038);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/TopCaterersCard.js + 2 modules
var TopCaterersCard = __webpack_require__(97010);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
// EXTERNAL MODULE: ./src/system/components/Button/DarkButton.js
var DarkButton = __webpack_require__(93925);
;// CONCATENATED MODULE: ./src/system/components/Button/TransparentButton.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  color: #3c4340;\n\n  :hover {\n    background-color: rgba(0, 0, 0, 0.07);\n  }\n\n  :active {\n    background-color: rgba(0, 0, 0, 0.2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TransparentButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(_templateObject());
/* harmony default export */ var Button_TransparentButton = (TransparentButton);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/index.js

function TopCaterers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n\n  ",
        " {\n    font-size: 36px;\n  }\n"
    ]);
    TopCaterers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 55px;\n  width: 55px;\n  border-radius: 100px;\n  padding: 0;\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: scaleX(-1);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  bottom: 0;\n  left: ",
        ";\n  right: ",
        ";\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n\n  scroll-snap-type: x mandatory;\n  margin-right: auto;\n  position: relative;\n  width: fit-content;\n  max-width: 100%;\n  overflow: auto;\n  display: flex;\n  gap: ",
        "px;\n  padding: ",
        ";\n  padding-bottom: ",
        "px;\n\n  @media (hover: hover) {\n    // No scrollbar on non-touch devices\n    overflow: hidden;\n  }\n\n  ",
        " {\n    padding-bottom: ",
        "px;\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    overflow: visible; // So the slide buttons will be visible\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin-left: auto;\n  position: relative;\n  width: fit-content;\n  scroll-snap-align: center;\n\n  scroll-behavior: smooth;\n  max-width: 100%;\n  margin-right: auto;\n  display: flex;\n\n  gap: ",
        "px;\n\n  align-items: stretch;\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

















var PAGINATION = {
    XS: {
        itemsPerPage: 1,
        maxPages: 6
    },
    SM: {
        itemsPerPage: 2,
        maxPages: 6
    },
    MD: {
        itemsPerPage: 3,
        maxPages: 4
    },
    LG: {
        itemsPerPage: 4,
        maxPages: 3
    }
};
var usePaginationSetup = function() {
    var isSM = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    var isMD = (0,useBreakpoints/* useBreakpointUp */._)("md");
    var isLG = (0,useBreakpoints/* useBreakpointUp */._)("lg");
    var paginationSetup = PAGINATION.XS;
    if (isSM) {
        paginationSetup = PAGINATION.SM;
    }
    if (isMD) {
        paginationSetup = PAGINATION.MD;
    }
    if (isLG) {
        paginationSetup = PAGINATION.LG;
    }
    return paginationSetup;
};
function TopCaterers(param) {
    var _topCaterers = param.topCaterers, topCaterers = _topCaterers === void 0 ? [] : _topCaterers, title = param.title, city = param.city, cta = param.cta, cateringCategories = param.cateringCategories, _ctaLink = param.ctaLink, ctaLink = _ctaLink === void 0 ? undefined : _ctaLink;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref1 = (0,react.useState)(false), isScrolling = ref1[0], setScrolling = ref1[1];
    var stopScrollingStateTimeoutRef = (0,react.useRef)(null);
    var paginationSetup = usePaginationSetup();
    var isDesktop = (0,useBreakpoints/* useBreakpointUp */._)("lg");
    var router = (0,next_router.useRouter)();
    var cardPageItemsRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        pagination.setPageIndex(0);
    }, [
        paginationSetup
    ]);
    (0,react.useEffect)(function() {
        return function() {
            if (stopScrollingStateTimeoutRef.current) {
                clearTimeout(stopScrollingStateTimeoutRef.current);
            }
        };
    }, []);
    var handleDotClick = function(index) {
        if (stopScrollingStateTimeoutRef.current) {
            clearTimeout(stopScrollingStateTimeoutRef.current);
        }
        setScrolling(true);
        pagination.setPageIndex(index);
        scrollPageIntoView(index);
        stopScrollingStateTimeoutRef.current = setTimeout(function() {
            return setScrolling(false);
        }, 800);
    };
    var pagination = (0,usePagination/* usePagination */.h)(topCaterers, {
        pageSize: paginationSetup.itemsPerPage,
        limit: paginationSetup.itemsPerPage * paginationSetup.maxPages
    });
    var ref2 = (0,react_intersection_observer_m/* useInView */.YD)(), isSectionInView = ref2.inView, sectionRef = ref2.ref;
    var scrollPageIntoView = function(pageIndex) {
        var ref;
        var pageElement = cardPageItemsRef === null || cardPageItemsRef === void 0 ? void 0 : (ref = cardPageItemsRef.current) === null || ref === void 0 ? void 0 : ref[pageIndex];
        if (isSectionInView && pageElement) {
            pageElement.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        }
    };
    if (topCaterers.length < 3) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    py: 6,
                    sm: {
                        py: 4
                    },
                    xs: {
                        py: 2
                    },
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        component: "h2",
                        gutterBottom: true,
                        children: title || "Top Caterers"
                    })
                })
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardsWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsGrid, {
                        children: (ref = pagination.currentPage) === null || ref === void 0 ? void 0 : ref.map(function(caterer) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterersCard/* default */.Z, {
                                caterer: caterer,
                                city: city
                            }, caterer.objectID);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButtonWrapper, {
                        left: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                            onClick: pagination.prev,
                            disabled: !pagination.prevPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                mr: 0.4,
                                mt: 0.4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButtonWrapper, {
                        right: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                            onClick: function() {
                                return handleDotClick(pagination.pageIndex + 1);
                            },
                            disabled: !pagination.nextPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                ml: 0.6,
                                mt: 0.4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {})
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsWrapper, {
                ref: sectionRef,
                children: pagination.pages.map(function(page, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                        threshold: 1,
                        onChange: function(inView) {
                            if (inView && !isScrolling) {
                                pagination.setPageIndex(index);
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsGrid, {
                            ref: function(element) {
                                cardPageItemsRef.current[index] = element;
                            },
                            children: page.length ? page.map(function(caterer) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterersCard/* default */.Z, {
                                    caterer: caterer,
                                    city: city
                                }, caterer.objectID);
                            }) : null
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                textAlign: "center",
                mt: {
                    xs: 2,
                    md: 3
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                    count: pagination.pageCount,
                    activeIndex: pagination.pageIndex,
                    onClick: handleDotClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                size: "md",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    pt: {
                        xs: 4,
                        md: 6
                    },
                    pb: 4,
                    textAlign: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DarkButton/* default */.Z, {
                        size: "lg",
                        rounded: true,
                        as: "a",
                        target: "_blank",
                        href: ctaLink || (0,helpers/* buildFunnelUrl */.$e)({
                            city: city,
                            cateringCategories: cateringCategories,
                            router: router
                        }),
                        children: cta ? cta : t("catererCards.cta")
                    })
                })
            })
        ]
    });
}
var TitleTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(TopCaterers_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var SlideButton = (0,styled_components_browser_esm/* default */.ZP)(Button_TransparentButton)(_templateObject1());
var ArrowBackIos = (0,styled_components_browser_esm/* default */.ZP)(ArrowForwardIos/* default */.Z)(_templateObject2());
var SlideButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(param) {
    var left = param.left;
    return left ? "-60px" : "none";
}, function(param) {
    var right = param.right;
    return right ? "-60px" : "none";
});
var CardsWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var CardsGrid = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});


/***/ }),

/***/ 27258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65576);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85444);
/* harmony import */ var _icons_star_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99859);
/* harmony import */ var _icons_trusted_shop_badge_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75006);
/* harmony import */ var qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19916);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: -5px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        "px;\n\n  ",
        " {\n    margin-top: ",
        "px;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  display: none;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    display: block;\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  gap: ",
        "px;\n\n  padding-bottom: ",
        "px;\n  padding-top: ",
        "px;\n  padding-right: ",
        "px;\n\n  ",
        " {\n    flex-direction: column;\n    padding-bottom: ",
        "px;\n    width: 100%;\n    gap: 0px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 172.5%;\n  color: ",
        ";\n\n  margin-right: ",
        "px;\n  ",
        " {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 172.5%;\n  align-self: center;\n\n  color: #273635;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 100px;\n\n  background-color: ",
        ";\n\n  margin-left: ",
        "px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 30px;\n  min-width: 30px;\n\n  ",
        " {\n    height: 46px;\n    min-width: 46px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        "px;\n  background-color: #f9fcea;\n\n  ",
        " {\n    background-color: inherit;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}









var Ratings = function(param) {
    var rating = param.rating;
    var isTablet = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpointUp */ ._)("lg");
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("common").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_trusted_shop_badge_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    fill: "white",
                    height: isTablet ? "22px" : "16px",
                    width: isTablet ? "22px" : "16px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ContentWrapper, {
                pr: 3.5,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RatingTitle, {
                        variant: "h4",
                        children: t("trustedShops.ratingText")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Stars, {
                        children: Array(Math.ceil(rating)).fill(1).map(function(_, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_icons_star_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                height: "10px",
                                width: "10px"
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RatingText, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RatingNumber, {
                                children: [
                                    rating.toFixed(1),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RatingFrom, {
                                children: "/ 5.0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var RatingText = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject());
var Stars = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject1(), function(param) {
    var spacing = param.theme.spacing;
    return spacing(0.4);
}, function(param) {
    var breakpoints = param.theme.breakpoints;
    return breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0.5);
});
var RatingTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0);
});
var ContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var RatingNumber = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.main;
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var RatingFrom = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject5());
var IconWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.main;
}, function(param) {
    var spacing = param.theme.spacing;
    return spacing(1.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div */ .ZP.div(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("lg");
});
/* harmony default export */ __webpack_exports__["Z"] = (Ratings);


/***/ }),

/***/ 66972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  filter: brightness(10); // So the images are white\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function TrustedCustomers() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(WrapperBox, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mx: "auto",
        flexWrap: "wrap",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mx: 3,
                my: 2,
                width: {
                    xs: 35,
                    md: 46
                },
                height: {
                    xs: 35,
                    md: 46
                },
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                    alt: "The logo of Dell",
                    src: "/artifacts/images/homepage/trust-customer-icons/dell.webp",
                    layout: "responsive",
                    width: "46",
                    height: "46"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mx: 3,
                my: 2,
                width: {
                    xs: 67,
                    md: 103
                },
                height: {
                    xs: 12,
                    md: 25
                },
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                    alt: "The logo of Infarm",
                    src: "/artifacts/images/homepage/trust-customer-icons/infarm.webp",
                    layout: "responsive",
                    width: "103",
                    height: "25"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mx: 3,
                my: 2,
                width: 62,
                height: {
                    xs: 13,
                    md: 25
                },
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                    alt: "The logo of Ebay",
                    src: "/artifacts/images/homepage/trust-customer-icons/ebay.webp",
                    layout: "responsive",
                    width: "62",
                    height: "25"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mx: 3,
                my: 2,
                width: {
                    xs: 44,
                    md: 66
                },
                height: {
                    xs: 22,
                    md: 32
                },
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                    alt: "The logo of Hellofresh",
                    src: "/artifacts/images/homepage/trust-customer-icons/hellofresh.webp",
                    layout: "responsive",
                    width: "66",
                    height: "32"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mx: 3,
                my: 2,
                width: {
                    xs: 47,
                    md: 56
                },
                height: {
                    xs: 9,
                    md: 20
                },
                position: "relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomerLogo, {
                    alt: "The logo of Audi",
                    src: "/artifacts/images/homepage/trust-customer-icons/audi.webp",
                    layout: "responsive",
                    width: "56",
                    height: "20"
                })
            })
        ]
    });
}
var WrapperBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject());
var CustomerLogo = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)((next_image__WEBPACK_IMPORTED_MODULE_4___default()))(_templateObject1(), function(props) {
    return props.theme.spacing(0, 10);
});
/* harmony default export */ __webpack_exports__["Z"] = (TrustedCustomers);


/***/ }),

/***/ 93925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95197);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border: 1px solid #3c4340;\n          color: #3c4340;\n          background-color: transparent;\n          :hover {\n            background-color: rgba(0, 0, 0, 0.07);\n            border-color: inherit;\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          background-color: #3c4340;\n          :hover {\n            background-color: #242927;\n          }\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  line-height: 1;\n  min-height: 42px;\n  display: inline-grid;\n  place-content: center;\n  white-space: normal;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var DarkButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx)(_templateObject2(), function(param) {
    var outline = param.outline;
    return outline ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
});
/* harmony default export */ __webpack_exports__["Z"] = (DarkButton);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1664,7879,9433,2311,7766,8184,1507,4566,4872,6649,9743,3992,9648,5627,8522,3791,3690,4254,3704,5643,7516,6888,7317,1402,9774,2888,179], function() { return __webpack_exec__(75332); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);